// // src/pages/buyer/my-requests/MyRequests.jsx

// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import withAuth from '../../auth/WithAuth';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';
// import {
//   FaStar,
//   FaCamera,
//   FaImage,
//   FaUserCircle,
//   FaBriefcase,
//   FaCheckCircle,
//   FaClock,
//   FaFileAlt,
//   FaTimes,
//   FaMoneyBillWave,
//   FaCalendar,
//   FaEnvelope,
//   FaComments,
//   FaSpinner,
//   FaRocket,
//   FaProjectDiagram,
//   FaHandshake,
//   FaWallet,
//   FaCreditCard,
//   FaMobileAlt,
//   FaUniversity,
// } from 'react-icons/fa';
// import './myrequests.scss';
// import FurnitureNavbar from '../../../components/layout/Nav';

// const MyRequests = () => {
//   // ========== STATE MANAGEMENT ==========
//   const [requests, setRequests] = useState([]);
//   const [filter, setFilter] = useState('all');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [matchedArtisans, setMatchedArtisans] = useState([]);
//   const [loadingMatches, setLoadingMatches] = useState(false);
//   const [viewRequest, setViewRequest] = useState(null);
//   const [editRequest, setEditRequest] = useState(null);
//   const [deleteRequest, setDeleteRequest] = useState(null);
//   const [portfolioModal, setPortfolioModal] = useState(null);
//   const [showProposalModal, setShowProposalModal] = useState(false);
//   const [viewingProposal, setViewingProposal] = useState(null);
//   const [loadingProposal, setLoadingProposal] = useState(false);
//   const [acceptingProposal, setAcceptingProposal] = useState(false);
//   const [autoOpenProjectId, setAutoOpenProjectId] = useState(null);
//   const [showPriceAgreedMessage, setShowPriceAgreedMessage] = useState(false);
//   const [selectedArtisanId, setSelectedArtisanId] = useState(null);
//   const [rating, setRating] = useState(0);
//   const [hoverRating, setHoverRating] = useState(0);
//   const [ratingReview, setRatingReview] = useState('');
//   const [ratingImages, setRatingImages] = useState([]);
//   const [ratingPreviewUrls, setRatingPreviewUrls] = useState([]);
//   const [existingRating, setExistingRating] = useState(null);
//   const [isSubmittingRating, setIsSubmittingRating] = useState(false);
//   const [activeImage, setActiveImage] = useState(0);
//   const [carouselIndex, setCarouselIndex] = useState({});
//   const [expandedBios, setExpandedBios] = useState({});
//   const [expandedDescriptions, setExpandedDescriptions] = useState({});
//   const [showConfirmModal, setShowConfirmModal] = useState(false);
//   const [selectedMatchForConfirm, setSelectedMatchForConfirm] = useState(null);
//   const [projectData, setProjectData] = useState({
//     title: '',
//     description: '',
//     budget: '',
//     location: '',
//     deadline: '',
//   });
//   const [newImages, setNewImages] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);

//   // ========== PAYMENT STATE MANAGEMENT ==========
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedProjectForPayment, setSelectedProjectForPayment] =
//     useState(null);
//   const [paymentLoading, setPaymentLoading] = useState(false);
//   const [paymentData, setPaymentData] = useState(null);
//   const [paymentType, setPaymentType] = useState('deposit');
//   const [paymentMethod, setPaymentMethod] = useState('mpesa');

//   // ========== FINAL PAYMENT STATE MANAGEMENT ==========
//   const [showFinalPaymentModal, setShowFinalPaymentModal] = useState(false);
//   const [selectedProjectForFinalPayment, setSelectedProjectForFinalPayment] =
//     useState(null);
//   const [finalPaymentLoading, setFinalPaymentLoading] = useState(false);

//   const navigate = useNavigate();

//   // ========== UI HELPERS ==========
//   const shouldShowEditDelete = (status) =>
//     ['open', 'pending'].includes(status?.toLowerCase());

//   const isPaymentPending = (status) =>
//     ['awaiting deposit payment', 'pending payment', 'payment pending'].some(
//       (s) => status?.toLowerCase().includes(s),
//     );

//   const shouldShowPayButton = (status) => {
//     if (!status) return false;
//     const lowerStatus = status.toLowerCase();
//     return (
//       lowerStatus === 'awaiting deposit payment' ||
//       lowerStatus === 'awaiting-final-payment' ||
//       lowerStatus === 'awaiting final payment' ||
//       lowerStatus === 'pending payment' ||
//       lowerStatus === 'payment pending' ||
//       lowerStatus === 'awaiting payment'
//     );
//   };

//   const isAwaitingFinalPayment = (status) => {
//     return (
//       status?.toLowerCase() === 'awaiting-final-payment' ||
//       status?.toLowerCase() === 'awaiting final payment'
//     );
//   };

//   const normalize = (str) => str?.toLowerCase().replace(/\s+/g, '');

//   const filteredRequests =
//     filter === 'all'
//       ? requests
//       : requests.filter((r) => normalize(r.status) === normalize(filter));

//   // ========== API FUNCTIONS ==========
//   const fetchClientProjects = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await serverUrlAuth.get('projects/client-projects/');
//       setRequests(res.data);
//     } catch (err) {
//       console.error('Error fetching projects:', err);
//       setError('Failed to fetch project requests.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const fetchMatchedArtisans = async (projectId) => {
//   //   setLoadingMatches(true);
//   //   try {
//   //     const res = await serverUrlAuth.get(
//   //       `projects/client/projects/${projectId}/matches/`,
//   //     );
//   //     console.log('Matched artisans response:', res.data);
//   //     setMatchedArtisans(res.data);
//   //   } catch (err) {
//   //     console.error('Error fetching matched artisans:', err);
//   //     toast.error('Failed to load matched artisans');
//   //   } finally {
//   //     setLoadingMatches(false);
//   //   }
//   // };
// const fetchMatchedArtisans = async (projectId) => {
//   setLoadingMatches(true);
//   try {
//     const res = await serverUrlAuth.get(
//       `projects/client/projects/${projectId}/matches/`,
//     );
//     console.log('Matched artisans response:', res.data);

//     // Sort artisans: those with proposals first
//     const sortedArtisans = res.data.sort((a, b) => {
//       // First, check if either has a proposal
//       const aHasProposal = a.has_proposal === true;
//       const bHasProposal = b.has_proposal === true;

//       // If one has a proposal and the other doesn't, the one with proposal comes first
//       if (aHasProposal && !bHasProposal) return -1;
//       if (!aHasProposal && bHasProposal) return 1;

//       // If both have proposals or both don't, sort by other criteria
//       // Option 1: Sort by proposal selection status (selected proposals first)
//       if (aHasProposal && bHasProposal) {
//         const aSelected = a.proposal_selected === true;
//         const bSelected = b.proposal_selected === true;
//         if (aSelected && !bSelected) return -1;
//         if (!aSelected && bSelected) return 1;
//       }

//       // Option 2: Sort by rating (higher rating first)
//       const aRating = parseFloat(a.average_rating) || 0;
//       const bRating = parseFloat(b.average_rating) || 0;
//       if (aRating !== bRating) return bRating - aRating;

//       // Option 3: Sort by artisan name (alphabetical)
//       return (a.artisan_name || '').localeCompare(b.artisan_name || '');
//     });

//     setMatchedArtisans(sortedArtisans);
//   } catch (err) {
//     console.error('Error fetching matched artisans:', err);
//     toast.error('Failed to load matched artisans');
//   } finally {
//     setLoadingMatches(false);
//   }
// };
//   const fetchProposalDetails = async (proposalId) => {
//     setLoadingProposal(true);
//     try {
//       const response = await serverUrlAuth.get(
//         `proposals/proposal-detail/${proposalId}/`,
//       );
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching proposal details:', error);
//       toast.error('Failed to load proposal details');
//       return null;
//     } finally {
//       setLoadingProposal(false);
//     }
//   };

//   const fetchPortfolioData = async (artisanId) => {
//     try {
//       const response = await serverUrlAuth.get(
//         `portfolio/artisan-portfolio/${artisanId}/`,
//       );
//       return response.data;
//     } catch (err) {
//       console.error('Error fetching portfolio:', err);
//     }
//   };

//   const fetchRating = async () => {
//     if (!viewRequest?.id) return;
//     try {
//       const res = await serverUrlAuth.get(
//         `reviews/project-review/${viewRequest.id}/`,
//       );
//       if (res.data) {
//         setExistingRating(res.data);
//         setRating(res.data.score || 0);
//         setRatingReview(res.data.review || '');
//         setRatingPreviewUrls(
//           res.data.images?.map((img) => img.image_url) || [],
//         );
//       }
//     } catch (err) {
//       if (err.response?.status !== 404) {
//         toast.error('Failed to fetch rating');
//       }
//     }
//   };

//   // ========== PAYMENT HANDLERS ==========
//   const handlePayNow = async (project) => {
//     setPaymentLoading(true);
//     try {
//       let proposalId = null;
//       let artisanId = null;
//       let artisanName = 'Artisan';

//       console.log('🔍 Handling payment for project:', project.id);

//       // First, try to find the proposal from matchedArtisans state
//       if (matchedArtisans.length > 0) {
//         console.log('Looking for proposal in matched artisans...');
//         const matchedArtisan = matchedArtisans.find(
//           (m) => m.proposal_selected === true || m.has_proposal === true,
//         );
//         if (matchedArtisan) {
//           proposalId = matchedArtisan.proposal_id;
//           artisanId = matchedArtisan.artisan_id;
//           artisanName = matchedArtisan.artisan_name || 'Artisan';
//           console.log('✅ Found proposal in matched artisans:', proposalId);
//         }
//       }

//       // If not found in matchedArtisans, try to fetch proposals
//       if (!proposalId) {
//         console.log('Fetching proposals for project:', project.id);
//         try {
//           const proposalsResponse = await serverUrlAuth.get(
//             `proposals/proposals-list/${project.id}/`,
//           );
//           const proposals = proposalsResponse.data;

//           console.log('📋 Proposals found:', proposals.length);

//           if (proposals && proposals.length > 0) {
//             const selectedProposal =
//               proposals.find((p) => p.is_selected === true) || proposals[0];
//             proposalId = selectedProposal.id;
//             artisanId =
//               selectedProposal.artisan_id || selectedProposal.artisan?.id;
//             artisanName =
//               selectedProposal.artisan_name ||
//               selectedProposal.artisan?.name ||
//               'Artisan';
//             console.log('✅ Found proposal from API:', proposalId);
//           }
//         } catch (error) {
//           console.error('Error fetching proposals:', error);
//           toast.error('Unable to fetch proposal details');
//           setPaymentLoading(false);
//           return;
//         }
//       }

//       if (!proposalId) {
//         toast.error(
//           'No proposal found for this project. Please contact support.',
//         );
//         setPaymentLoading(false);
//         return;
//       }

//       const agreedAmount = project.agreed_cost || project.budget || 0;

//       // Check if this is a final payment
//       if (isAwaitingFinalPayment(project.status)) {
//         setSelectedProjectForFinalPayment({
//           id: project.id,
//           proposal_id: proposalId,
//           title: project.title,
//           artisan_name: artisanName,
//           artisan_id: artisanId,
//           agreed_cost: parseFloat(agreedAmount),
//           budget: parseFloat(project.budget || 0),
//         });
//         setShowFinalPaymentModal(true);
//         setViewRequest(null);
//         setPaymentLoading(false);
//         return;
//       }

//       // Regular deposit payment
//       setSelectedProjectForPayment({
//         id: project.id,
//         proposal_id: proposalId,
//         title: project.title,
//         artisan_name: artisanName,
//         artisan_id: artisanId,
//         agreed_cost: parseFloat(agreedAmount),
//         budget: parseFloat(project.budget || 0),
//       });

//       setPaymentType('deposit');
//       setShowPaymentModal(true);
//       setViewRequest(null);
//     } catch (error) {
//       console.error('Error initializing payment:', error);
//       toast.error('Failed to initialize payment. Please try again.');
//     } finally {
//       setPaymentLoading(false);
//     }
//   };

//   // ========== DEPOSIT PAYMENT ==========
//   const initializeDepositPayment = async (proposalId) => {
//     setPaymentLoading(true);
//     try {
//       if (!proposalId) {
//         toast.error('Proposal ID is required');
//         setPaymentLoading(false);
//         return;
//       }

//       const payload = {
//         proposal_id: proposalId,
//         payment_type: 'deposit',
//       };

//       console.log('📤 Sending deposit payment payload:', payload);

//       const response = await serverUrlAuth.post(
//         'payments/initialize/',
//         payload,
//       );

//       console.log('📥 Payment response:', response.data);

//       if (response.data.status === true) {
//         setPaymentData(response.data);

//         const {
//           authorization_url,
//           reference,
//           access_code,
//           amount,
//           payment_type: responsePaymentType,
//         } = response.data;

//         sessionStorage.setItem('currentPaymentReference', reference);
//         sessionStorage.setItem(
//           'currentProjectId',
//           selectedProjectForPayment?.id || '',
//         );
//         sessionStorage.setItem('currentPaymentAmount', amount);
//         sessionStorage.setItem('currentPaymentType', responsePaymentType);

//         toast.success(
//           `Deposit payment initialized! Amount: KSh ${parseFloat(amount).toLocaleString()}`,
//         );

//         const paymentWindow = window.open(
//           authorization_url,
//           '_blank',
//           'noopener,noreferrer',
//         );

//         if (
//           !paymentWindow ||
//           paymentWindow.closed ||
//           typeof paymentWindow.closed === 'undefined'
//         ) {
//           toast.warning('Popup blocked! Please allow popups for this site.');
//           toast.info(
//             <div>
//               Click here to complete payment:
//               <a
//                 href={authorization_url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 {authorization_url}
//               </a>
//             </div>,
//             { autoClose: 15000 },
//           );
//         }

//         setShowPaymentModal(false);
//         setSelectedProjectForPayment(null);

//         toast.info(
//           '💳 Complete payment in the Paystack window. Your project will update automatically after payment.',
//           { autoClose: 10000 },
//         );

//         startPaymentPolling(reference);
//       } else {
//         const errorMessage =
//           response.data.message || 'Payment initialization failed';
//         toast.error(errorMessage);
//       }
//     } catch (error) {
//       console.error('❌ Payment initialization error:', error);
//       console.error('Error response:', error.response?.data);

//       let errorMessage = 'Failed to initialize payment. Please try again.';

//       if (error.response) {
//         const data = error.response.data;
//         if (data.message) errorMessage = data.message;
//         else if (data.detail) errorMessage = data.detail;
//         else if (data.error) errorMessage = data.error;

//         if (data.errors) {
//           const errorList = Object.values(data.errors).flat().join(', ');
//           errorMessage = `Validation error: ${errorList}`;
//         }

//         if (error.response.status === 400) {
//           errorMessage =
//             'Invalid request. Please check the proposal ID and payment type.';
//         } else if (error.response.status === 401) {
//           errorMessage = 'Authentication error. Please login again.';
//         } else if (error.response.status === 403) {
//           errorMessage = 'You do not have permission to make this payment.';
//         } else if (error.response.status === 404) {
//           errorMessage = 'Proposal not found. Please try again.';
//         } else if (error.response.status === 500) {
//           errorMessage = 'Server error. Please try again later.';
//         }
//       } else if (error.request) {
//         errorMessage =
//           'No response from server. Please check your internet connection.';
//       }

//       toast.error(errorMessage);
//     } finally {
//       setPaymentLoading(false);
//     }
//   };

//   // ========== FINAL PAYMENT ==========
//   const initializeFinalPayment = async (proposalId) => {
//     setFinalPaymentLoading(true);
//     try {
//       if (!proposalId) {
//         toast.error('Proposal ID is required');
//         setFinalPaymentLoading(false);
//         return;
//       }

//       const payload = {
//         proposal_id: proposalId,
//         payment_type: 'balance',
//       };

//       console.log('📤 Sending final payment payload:', payload);

//       const response = await serverUrlAuth.post(
//         'payments/initialize/',
//         payload,
//       );

//       console.log('📥 Payment response:', response.data);

//       if (response.data.status === true) {
//         setPaymentData(response.data);

//         const {
//           authorization_url,
//           reference,
//           access_code,
//           amount,
//           payment_type: responsePaymentType,
//         } = response.data;

//         sessionStorage.setItem('currentPaymentReference', reference);
//         sessionStorage.setItem(
//           'currentProjectId',
//           selectedProjectForFinalPayment?.id || '',
//         );
//         sessionStorage.setItem('currentPaymentAmount', amount);
//         sessionStorage.setItem('currentPaymentType', responsePaymentType);

//         toast.success(
//           `Final payment initialized! Amount: KSh ${parseFloat(amount).toLocaleString()}`,
//         );

//         const paymentWindow = window.open(
//           authorization_url,
//           '_blank',
//           'noopener,noreferrer',
//         );

//         if (
//           !paymentWindow ||
//           paymentWindow.closed ||
//           typeof paymentWindow.closed === 'undefined'
//         ) {
//           toast.warning('Popup blocked! Please allow popups for this site.');
//           toast.info(
//             <div>
//               Click here to complete payment:
//               <a
//                 href={authorization_url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 {authorization_url}
//               </a>
//             </div>,
//             { autoClose: 15000 },
//           );
//         }

//         setShowFinalPaymentModal(false);
//         setSelectedProjectForFinalPayment(null);

//         toast.info(
//           '💳 Complete payment in the Paystack window. Your project will be marked as completed after payment.',
//           { autoClose: 10000 },
//         );

//         startPaymentPolling(reference);
//       } else {
//         const errorMessage =
//           response.data.message || 'Payment initialization failed';
//         toast.error(errorMessage);
//       }
//     } catch (error) {
//       console.error('❌ Final payment initialization error:', error);
//       console.error('Error response:', error.response?.data);

//       let errorMessage =
//         'Failed to initialize final payment. Please try again.';

//       if (error.response) {
//         const data = error.response.data;
//         if (data.message) errorMessage = data.message;
//         else if (data.detail) errorMessage = data.detail;
//         else if (data.error) errorMessage = data.error;

//         if (data.errors) {
//           const errorList = Object.values(data.errors).flat().join(', ');
//           errorMessage = `Validation error: ${errorList}`;
//         }

//         if (error.response.status === 400) {
//           errorMessage =
//             'Invalid request. Please check the proposal ID and payment type.';
//         } else if (error.response.status === 401) {
//           errorMessage = 'Authentication error. Please login again.';
//         } else if (error.response.status === 403) {
//           errorMessage = 'You do not have permission to make this payment.';
//         } else if (error.response.status === 404) {
//           errorMessage = 'Proposal not found. Please try again.';
//         } else if (error.response.status === 500) {
//           errorMessage = 'Server error. Please try again later.';
//         }
//       } else if (error.request) {
//         errorMessage =
//           'No response from server. Please check your internet connection.';
//       }

//       toast.error(errorMessage);
//     } finally {
//       setFinalPaymentLoading(false);
//     }
//   };

//   const startPaymentPolling = (reference) => {
//     let attempts = 0;
//     const maxAttempts = 60;
//     const intervalId = setInterval(async () => {
//       attempts++;
//       console.log(
//         `🔍 Checking payment status (Attempt ${attempts}/${maxAttempts})...`,
//       );

//       try {
//         const projectId = sessionStorage.getItem('currentProjectId');

//         if (!projectId) {
//           console.log('No project ID found, stopping polling');
//           clearInterval(intervalId);
//           return;
//         }

//         const response = await serverUrlAuth.get(
//           `projects/client-project/${projectId}/`,
//         );
//         const project = response.data;

//         console.log(
//           '📊 Project status:',
//           project.status,
//           'Payment status:',
//           project.payment_status,
//         );

//         const paymentCompleted =
//           project.payment_status === 'completed' ||
//           project.status?.toLowerCase() === 'in-progress' ||
//           project.status?.toLowerCase() === 'awaiting artisan' ||
//           project.status?.toLowerCase() === 'active' ||
//           project.status?.toLowerCase() === 'completed';

//         if (paymentCompleted) {
//           console.log('✅ Payment verified successfully!');
//           toast.success('🎉 Payment confirmed! Your project is now active.');
//           clearInterval(intervalId);

//           sessionStorage.removeItem('currentPaymentReference');
//           sessionStorage.removeItem('currentProjectId');
//           sessionStorage.removeItem('currentPaymentAmount');
//           sessionStorage.removeItem('currentPaymentType');

//           fetchClientProjects();
//           navigate('/payments');
//           return;
//         }

//         if (attempts >= maxAttempts) {
//           clearInterval(intervalId);
//           console.log('⏰ Max polling attempts reached');
//           toast.info(
//             'Payment verification taking longer than expected. Check your payments page for status.',
//             { autoClose: 5000 },
//           );
//           navigate('/payments');
//           return;
//         }
//       } catch (error) {
//         console.error('❌ Error checking payment status:', error);

//         if (error.response?.status === 404) {
//           clearInterval(intervalId);
//           toast.warning('Project not found. Please check your projects page.');
//           navigate('/payments');
//           return;
//         }

//         if (attempts >= maxAttempts) {
//           clearInterval(intervalId);
//           toast.info(
//             'Payment verification timeout. Check your payments page for status.',
//           );
//           navigate('/payments');
//         }
//       }
//     }, 3000);

//     sessionStorage.setItem('pollingIntervalId', intervalId);
//   };

//   // ========== PROJECT MANAGEMENT FUNCTIONS ==========
//   const handleDeleteProject = async () => {
//     if (!deleteRequest) return;
//     try {
//       await serverUrlAuth.delete(
//         `projects/client-project/${deleteRequest.id}/`,
//       );
//       toast.success(`Project "${deleteRequest.title}" deleted`);
//       setRequests((prev) => prev.filter((r) => r.id !== deleteRequest.id));
//       setDeleteRequest(null);
//     } catch (err) {
//       toast.error('Failed to delete project');
//     }
//   };

//   const handleEditProject = async () => {
//     if (!editRequest) return;
//     try {
//       const formData = new FormData();
//       Object.entries(projectData).forEach(([key, value]) =>
//         formData.append(key, value),
//       );
//       newImages.forEach((file) => formData.append('images', file));

//       await serverUrlAuth.patch(
//         `projects/client-project/${editRequest.id}/`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } },
//       );

//       toast.success(`Project "${projectData.title}" updated`);
//       setEditRequest(null);
//       resetEditForm();
//       fetchClientProjects();
//     } catch (err) {
//       toast.error('Failed to update project');
//     }
//   };

//   // ========== RATING FUNCTIONS ==========
//   const handleSubmitRating = async () => {
//     if (!rating || !viewRequest?.id) {
//       toast.error('Please select a rating');
//       return;
//     }

//     setIsSubmittingRating(true);
//     try {
//       const formData = new FormData();
//       formData.append('score', rating);
//       formData.append('review', ratingReview);
//       ratingImages.forEach((file) => formData.append('images', file));

//       const res = await serverUrlAuth.post(
//         `reviews/project-review/${viewRequest.id}/create/`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } },
//       );

//       toast.success('Review submitted successfully!');
//       setExistingRating(res.data);
//       resetRatingForm();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Failed to submit rating');
//     } finally {
//       setIsSubmittingRating(false);
//     }
//   };

//   // ========== UI HANDLERS ==========
//   // ✅ Updated handleSelectArtisan - now accepts enriched data
//   const handleSelectArtisan = (match) => {
//     if (!match.has_proposal) {
//       toast.error('No proposal found for this artisan');
//       return;
//     }

//     // ✅ If we have viewingProposal data, enrich the match
//     if (viewingProposal && viewingProposal.proposal_id === match.proposal_id) {
//       match = {
//         ...match,
//         proposed_price: viewingProposal.proposed_price,
//         final_agreed_amount:
//           viewingProposal.final_agreed_amount || viewingProposal.proposed_price,
//       };
//     }

//     setSelectedMatchForConfirm(match);
//     setShowConfirmModal(true);
//   };

//   // ✅ Handle viewing proposal details - store complete data
//   const handleViewProposal = async (match) => {
//     if (!match.has_proposal || !match.proposal_id) {
//       toast.error('No proposal found for this artisan');
//       return;
//     }

//     try {
//       const proposal = await fetchProposalDetails(match.proposal_id);
//       if (proposal) {
//         setViewingProposal({
//           ...proposal,
//           artisan_name: match.artisan_name,
//           artisan_id: match.artisan_id,
//           proposal_id: match.proposal_id,
//           // ✅ Store the price data for selection
//           proposed_price: proposal.proposed_price,
//           final_agreed_amount:
//             proposal.final_agreed_amount || proposal.proposed_price,
//         });
//         setShowProposalModal(true);
//       }
//     } catch (error) {
//       console.error('Error viewing proposal:', error);
//       toast.error('Failed to load proposal details');
//     }
//   };

//   const confirmSelectArtisan = async () => {
//     if (!selectedMatchForConfirm) return;

//     setAcceptingProposal(true);
//     try {
//       await serverUrlAuth.patch(
//         `proposals/${selectedMatchForConfirm.proposal_id}/select/`,
//       );

//       toast.success(
//         `You have selected ${selectedMatchForConfirm.artisan_name} for this project!`,
//       );

//       setShowConfirmModal(false);

//       const agreedAmount =
//         selectedMatchForConfirm.final_agreed_amount ||
//         selectedMatchForConfirm.proposed_price ||
//         viewRequest?.budget;

//       setSelectedProjectForPayment({
//         id: viewRequest.id,
//         proposal_id: selectedMatchForConfirm.proposal_id,
//         title: viewRequest.title,
//         artisan_name: selectedMatchForConfirm.artisan_name,
//         artisan_id: selectedMatchForConfirm.artisan_id,
//         agreed_cost: parseFloat(agreedAmount),
//         budget: parseFloat(viewRequest?.budget || 0),
//       });

//       setShowPaymentModal(true);
//       setViewRequest(null);
//       fetchClientProjects();
//       setSelectedMatchForConfirm(null);
//     } catch (err) {
//       console.error('Error selecting artisan:', err);
//       toast.error(err.response?.data?.message || 'Failed to select artisan');
//     } finally {
//       setAcceptingProposal(false);
//     }
//   };

//   const handleViewProject = async (project) => {
//     setViewRequest(project);
//     if (project.status?.toLowerCase() === 'open') {
//       await fetchMatchedArtisans(project.id);
//     }
//     if (project.status?.toLowerCase() === 'completed') {
//       fetchRating();
//     }
//   };

//   const openPortfolio = async (artisanId, artisanName) => {
//     const portfolioData = await fetchPortfolioData(artisanId);
//     setPortfolioModal({ ...portfolioData, artisan_name: artisanName });
//     setViewRequest(null);
//   };

//   const closePortfolio = () => setPortfolioModal(null);

//   const openEditModal = (request) => {
//     setEditRequest(request);
//     setProjectData({
//       title: request.title || '',
//       description: request.description || '',
//       budget: request.budget || '',
//       location: request.location || '',
//       deadline: request.deadline?.split('T')[0] || '',
//     });
//     setNewImages([]);
//     setPreviewUrls([]);
//   };

//   const toggleBio = (artisanId) => {
//     setExpandedBios((prev) => ({
//       ...prev,
//       [artisanId]: !prev[artisanId],
//     }));
//   };

//   const toggleDescription = (projectId) => {
//     setExpandedDescriptions((prev) => ({
//       ...prev,
//       [projectId]: !prev[projectId],
//     }));
//   };

//   // ========== UTILITY FUNCTIONS ==========
//   const handleImageUpload = (e, setImages, setPreviews) => {
//     const files = Array.from(e.target.files);
//     setImages((prev) => [...prev, ...files]);
//     setPreviews((prev) => [
//       ...prev,
//       ...files.map((file) => URL.createObjectURL(file)),
//     ]);
//   };

//   const handleRemoveImage = (index, setImages, setPreviews) => {
//     setImages((prev) => prev.filter((_, i) => i !== index));
//     setPreviews((prev) => prev.filter((_, i) => i !== index));
//   };

//   const resetRatingForm = () => {
//     setRating(0);
//     setRatingReview('');
//     setRatingImages([]);
//     setRatingPreviewUrls([]);
//   };

//   const resetEditForm = () => {
//     setNewImages([]);
//     setPreviewUrls([]);
//   };

//   // ========== CAROUSEL FUNCTIONS ==========
//   const handleNext = (projectId, totalImages) => {
//     setCarouselIndex((prev) => ({
//       ...prev,
//       [projectId]: ((prev[projectId] || 0) + 1) % totalImages,
//     }));
//   };

//   const handlePrev = (projectId, totalImages) => {
//     setCarouselIndex((prev) => ({
//       ...prev,
//       [projectId]:
//         (prev[projectId] || 0) === 0
//           ? totalImages - 1
//           : (prev[projectId] || 0) - 1,
//     }));
//   };

//   // ========== TIER HELPERS ==========
//   const getTierBadgeClass = (tier) => {
//     switch (tier?.toLowerCase()) {
//       case 'bronze':
//         return 'tier-bronze';
//       case 'silver':
//         return 'tier-silver';
//       case 'gold':
//         return 'tier-gold';
//       default:
//         return 'tier-bronze';
//     }
//   };

//   const getTierIcon = (tier) => {
//     switch (tier?.toLowerCase()) {
//       case 'bronze':
//         return '🥉';
//       case 'silver':
//         return '🥈';
//       case 'gold':
//         return '🥇';
//       default:
//         return '🥉';
//     }
//   };

//   // ========== EFFECTS ==========
//   useEffect(() => {
//     const projectId = sessionStorage.getItem('openProjectMatches');
//     const showMessage = sessionStorage.getItem('showPriceAgreedMessage');
//     const artisanId = sessionStorage.getItem('selectedArtisanId');

//     if (projectId) {
//       setAutoOpenProjectId(projectId);
//       if (showMessage) {
//         setShowPriceAgreedMessage(true);
//         setTimeout(() => setShowPriceAgreedMessage(false), 5000);
//       }
//       if (artisanId) {
//         setSelectedArtisanId(artisanId);
//       }
//       sessionStorage.removeItem('openProjectMatches');
//       sessionStorage.removeItem('showPriceAgreedMessage');
//       sessionStorage.removeItem('selectedArtisanId');
//     }
//   }, []);

//   useEffect(() => {
//     if (autoOpenProjectId && requests.length > 0) {
//       const project = requests.find(
//         (r) => r.id.toString() === autoOpenProjectId.toString(),
//       );
//       if (project && project.status?.toLowerCase() === 'open') {
//         handleViewProject(project);
//         setAutoOpenProjectId(null);
//       }
//     }
//   }, [requests, autoOpenProjectId]);

//   useEffect(() => {
//     fetchClientProjects();
//   }, []);

//   useEffect(() => {
//     if (viewRequest) {
//       setActiveImage(0);
//       if (viewRequest.status?.toLowerCase() === 'open') {
//         fetchMatchedArtisans(viewRequest.id);
//       }
//       if (viewRequest.status?.toLowerCase() === 'completed') {
//         fetchRating();
//       } else {
//         resetRatingForm();
//         setExistingRating(null);
//       }
//     }
//   }, [viewRequest]);

//   if (loading) {
//     return (
//       <div className="modern-dashboard">
//         <div className="dashboard-loader">
//           <div className="wooden-spinner"></div>
//           <p>Crafting your experience...</p>
//         </div>
//       </div>
//     );
//   }

//   // ========== RENDER ==========
//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="modern-dashboard">
//         {/* Hero Section */}
//         <section className="hero-craftsmanship">
//           <div className="hero-pattern"></div>
//           <div className="hero-content-modern">
//             <div className="welcome-badge">
//               <span className="badge-icon">📋</span>
//               <span>My Project Requests</span>
//             </div>
//             <h1 className="hero-title">
//               <span className="gradient-text">Track & Manage</span>
//               <span className="hero-accent">Your Projects</span>
//             </h1>
//             <p className="hero-subtitle">
//               Keep track of all your custom furniture and design requests in one
//               place. Monitor progress, review proposals, and connect with
//               skilled artisans.
//             </p>
//             <div className="hero-actions">
//               <Link to="/new-project" className="btn-primary-custom">
//                 <FaRocket /> Create New Project
//               </Link>
//             </div>
//           </div>
//         </section>

//         {/* Quick Stats Dashboard */}
//         <div className="stats-dashboard">
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#67320020', color: '#673200' }}
//             >
//               <FaProjectDiagram />
//             </div>
//             <div className="stat-content">
//               <h3>
//                 {requests.filter((r) => r.status?.toLowerCase() === 'open')
//                   .length || 0}
//               </h3>
//               <p>Open Projects</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#4caf5020', color: '#4caf50' }}
//             >
//               <FaCheckCircle />
//             </div>
//             <div className="stat-content">
//               <h3>
//                 {requests.filter(
//                   (r) => r.status?.toLowerCase() === 'in-progress',
//                 ).length || 0}
//               </h3>
//               <p>In Progress</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#ff980020', color: '#ff9800' }}
//             >
//               <FaCheckCircle />
//             </div>
//             <div className="stat-content">
//               <h3>
//                 {requests.filter((r) => r.status?.toLowerCase() === 'completed')
//                   .length || 0}
//               </h3>
//               <p>Completed</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#9c27b020', color: '#9c27b0' }}
//             >
//               <FaHandshake />
//             </div>
//             <div className="stat-content">
//               <h3>
//                 {requests.reduce(
//                   (sum, r) => sum + (r.proposals_count || 0),
//                   0,
//                 ) || 0}
//               </h3>
//               <p>Total Proposals</p>
//             </div>
//           </div>
//         </div>

//         {/* Filter Section */}
//         <div className="filter-section-modern">
//           <div className="filter-tabs">
//             {['all', 'open', 'in-progress', 'completed'].map((status) => (
//               <button
//                 key={status}
//                 className={`filter-tab ${filter === status ? 'active' : ''}`}
//                 onClick={() => setFilter(status)}
//               >
//                 {status === 'all'
//                   ? 'All Projects'
//                   : status === 'in-progress'
//                     ? 'In Progress'
//                     : status.charAt(0).toUpperCase() + status.slice(1)}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Projects Grid */}
//         <div className="projects-showcase">
//           <div className="section-header-modern">
//             <h2>
//               <span className="header-icon">📋</span>
//               Your Projects
//               <span className="header-line"></span>
//             </h2>
//           </div>

//           {error ? (
//             <div className="error-state">
//               <p>{error}</p>
//               <button onClick={fetchClientProjects} className="retry-btn">
//                 Try Again
//               </button>
//             </div>
//           ) : filteredRequests.length === 0 ? (
//             <div className="empty-state-modern">
//               <div className="empty-icon">📭</div>
//               <h3>No projects found</h3>
//               <p>
//                 {requests.length === 0
//                   ? "You haven't created any projects yet."
//                   : `No ${filter !== 'all' ? filter : ''} projects found.`}
//               </p>
//               {requests.length === 0 && (
//                 <Link to="/new-project" className="btn-primary-custom">
//                   <FaRocket /> Create Your First Project
//                 </Link>
//               )}
//             </div>
//           ) : (
//             <div className="projects-grid-modern">
//               {filteredRequests.map((req) => (
//                 <div key={req.id} className="project-card-modern">
//                   {/* Image Section at the top */}
//                   <div className="card-image-section">
//                     <img
//                       src={
//                         req.images?.length
//                           ? req.images[0].image_url || req.images[0].image
//                           : 'https://via.placeholder.com/400x200?text=No+Image'
//                       }
//                       alt={req.title}
//                       className="card-image"
//                     />
//                     <span
//                       className={`status-badge-overlay ${req.status?.toLowerCase().replace(' ', '-')}`}
//                     >
//                       {req.status}
//                     </span>
//                     {req.proposals_count > 0 &&
//                       req.status?.toLowerCase() === 'open' && (
//                         <span className="proposals-badge-overlay">
//                           💼 {req.proposals_count}{' '}
//                           {req.proposals_count === 1 ? 'proposal' : 'proposals'}
//                         </span>
//                       )}
//                     {/* Payment Status Badge */}
//                     {isPaymentPending(req.status) && (
//                       <span className="payment-status-badge pending">
//                         💳 Payment Required
//                       </span>
//                     )}
//                     {req.payment_status === 'completed' && (
//                       <span className="payment-status-badge completed">
//                         ✅ Paid
//                       </span>
//                     )}
//                   </div>

//                   {/* Card Content */}
//                   <div className="card-content-section">
//                     {/* Pay Now Button - Top Section */}
//                     {shouldShowPayButton(req.status) && (
//                       <div className="pay-now-top-section">
//                         <button
//                           className="pay-now-top-btn"
//                           onClick={() => handlePayNow(req)}
//                           disabled={paymentLoading}
//                         >
//                           <FaWallet className="pay-icon" />
//                           <span className="pay-text">
//                             {isAwaitingFinalPayment(req.status)
//                               ? 'Pay Balance'
//                               : 'Pay Now'}
//                           </span>
//                           <span className="pay-amount">
//                             KSh{' '}
//                             {parseFloat(
//                               req.agreed_cost || req.budget || 0,
//                             ).toLocaleString()}
//                           </span>
//                         </button>
//                       </div>
//                     )}

//                     {/* Final Payment Banner */}
//                     {isAwaitingFinalPayment(req.status) && (
//                       <div className="final-payment-banner">
//                         <div className="banner-icon">🎉</div>
//                         <div className="banner-text">
//                           <h4>Project Complete!</h4>
//                           <p>
//                             Your project is ready. Make the final payment to
//                             complete.
//                           </p>
//                         </div>
//                       </div>
//                     )}

//                     <div className="project-header">
//                       <div className="project-title-section">
//                         <h3>{req.title}</h3>
//                       </div>
//                       <div className="project-budget">
//                         KSh{' '}
//                         {parseFloat(
//                           req.agreed_cost || req.budget || 0,
//                         ).toLocaleString()}
//                       </div>
//                     </div>

//                     <div className="project-details-preview">
//                       <p className="project-description-preview">
//                         {req.description?.substring(0, 80)}
//                         {req.description?.length > 80 ? '...' : ''}
//                       </p>
//                       <div className="project-meta">
//                         <span className="meta-item">
//                           <FaCalendar /> Due:{' '}
//                           {new Date(req.deadline).toLocaleDateString()}
//                         </span>
//                       </div>
//                     </div>

//                     <div className="project-footer-my-projects">
//                       <button
//                         className="project-action"
//                         onClick={() => handleViewProject(req)}
//                       >
//                         {req.status?.toLowerCase() === 'open'
//                           ? 'View Artisan Matches/Proposals '
//                           : req.status?.toLowerCase() === 'completed'
//                             ? existingRating
//                               ? 'View Review →'
//                               : 'Rate Project →'
//                             : isAwaitingFinalPayment(req.status)
//                               ? 'View Project →'
//                               : 'View Details →'}
//                       </button>

//                       {/* Pay Button - Only when status is awaiting deposit payment or final payment */}
//                       {(req.status?.toLowerCase() ===
//                         'awaiting-deposit-payment' ||
//                         isAwaitingFinalPayment(req.status)) && (
//                         <button
//                           className={`pay-action-btn ${
//                             isAwaitingFinalPayment(req.status)
//                               ? 'final-payment'
//                               : ''
//                           }`}
//                           onClick={() => handlePayNow(req)}
//                           disabled={paymentLoading || finalPaymentLoading}
//                         >
//                           <FaWallet />{' '}
//                           {isAwaitingFinalPayment(req.status)
//                             ? 'Pay Balance'
//                             : 'Pay Now'}
//                         </button>
//                       )}

//                       {shouldShowEditDelete(req.status) && (
//                         <div className="action-buttons">
//                           <button
//                             className="edit-action"
//                             onClick={() => openEditModal(req)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="delete-action"
//                             onClick={() => setDeleteRequest(req)}
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Project Details Modal with Matched Artisans */}
//         <Modal
//           show={!!viewRequest}
//           onHide={() => setViewRequest(null)}
//           centered
//           size="xl"
//           className="project-details-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {viewRequest?.status?.toLowerCase() === 'completed'
//                 ? 'Rate Project'
//                 : viewRequest?.status?.toLowerCase() === 'open'
//                   ? 'Matched Artisans'
//                   : 'Project Details'}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {viewRequest && (
//               <div className="modal-two-column-layout">
//                 {/* Left Side - Images */}
//                 <div className="modal-left-side">
//                   <div className="image-carousel">
//                     <div className="main-image-container">
//                       <img
//                         src={
//                           viewRequest.images?.length
//                             ? viewRequest.images[activeImage].image
//                             : 'https://via.placeholder.com/400x300?text=No+Image'
//                         }
//                         alt={viewRequest.title}
//                         className="main-image"
//                       />
//                     </div>
//                     {viewRequest.images?.length > 1 && (
//                       <div className="thumbnail-strip">
//                         {viewRequest.images.map((img, idx) => (
//                           <img
//                             key={idx}
//                             src={img.image}
//                             alt={`Thumb ${idx + 1}`}
//                             className={`thumbnail ${activeImage === idx ? 'active' : ''}`}
//                             onClick={() => setActiveImage(idx)}
//                           />
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Right Side - Content */}
//                 <div className="modal-right-side">
//                   <div className="content-section">
//                     <h3 className="project-title">{viewRequest.title}</h3>

//                     <div className="project-details">
//                       <p>
//                         <strong>Status:</strong> {viewRequest.status}
//                       </p>
//                       {!viewRequest.agreed_cost ? (
//                         <p>
//                           <strong>Budget:</strong> KSh{' '}
//                           {parseFloat(viewRequest.budget).toLocaleString()}
//                         </p>
//                       ) : (
//                         <p>
//                           <strong>Agreed Cost:</strong> KSh{' '}
//                           {parseFloat(viewRequest.agreed_cost).toLocaleString()}
//                         </p>
//                       )}
//                       <p>
//                         <strong>Deadline:</strong>{' '}
//                         {new Date(viewRequest.deadline).toLocaleDateString()}
//                       </p>
//                       <p>
//                         <strong>Location:</strong> {viewRequest.location}
//                       </p>
//                       <div className="description-section">
//                         <strong>Description:</strong>
//                         <p>{viewRequest.description}</p>
//                       </div>
//                     </div>

//                     {/* Matched Artisans Section for Open Projects */}
//                     {viewRequest.status?.toLowerCase() === 'open' && (
//                       <div className="matched-artisans-section">
//                         <div className="section-header">
//                           <h4>
//                             🤝 Matched Artisans ({matchedArtisans.length})
//                           </h4>
//                           <p className="match-info">
//                             Based on your budget of KSh{' '}
//                             {parseFloat(viewRequest.budget).toLocaleString()},
//                             we've found skilled artisans who match your
//                             requirements.
//                           </p>
//                         </div>

//                         {loadingMatches ? (
//                           <div className="loading-matches">
//                             <div className="spinner"></div>
//                             <p>Finding the best artisans for you...</p>
//                           </div>
//                         ) : matchedArtisans.length === 0 ? (
//                           <div className="no-matches">
//                             <div className="no-matches-icon">🔍</div>
//                             <h5>No matches found yet</h5>
//                             <p>
//                               We're still looking for artisans who match your
//                               requirements. Check back soon!
//                             </p>
//                           </div>
//                         ) : (
//                           <div className="matched-artisans-list">
//                             {matchedArtisans.map((match) => (
//                               <div
//                                 key={match.id}
//                                 className="matched-artisan-card"
//                               >
//                                 <div className="artisan-header">
//                                   <div className="artisan-avatar">
//                                     <FaUserCircle className="avatar-placeholder" />
//                                   </div>
//                                   <div className="artisan-info">
//                                     <h5>
//                                       {match.artisan_name ||
//                                         `Artisan ${match.artisan_id}`}
//                                     </h5>
//                                     <div className="artisan-meta">
//                                       <div className="rating">
//                                         <FaStar className="star-icon" />
//                                         <span>
//                                           {match.average_rating || 'New'}
//                                         </span>
//                                       </div>
//                                     </div>
//                                   </div>
//                                   <div className="match-status">
//                                     {match.has_proposal ? (
//                                       <span
//                                         className={`proposal-status-badge ${match.proposal_selected ? 'accepted' : 'pending'}`}
//                                       >
//                                         {match.proposal_selected
//                                           ? '✅ Selected'
//                                           : '📝 Proposal Received'}
//                                       </span>
//                                     ) : (
//                                       <span className="proposal-status-badge no-proposal">
//                                         <FaClock /> Waiting for Proposal
//                                       </span>
//                                     )}
//                                   </div>
//                                 </div>

//                                 <div className="artisan-bio-preview">
//                                   <p>
//                                     {match.bio ||
//                                       'Skilled artisan ready to work on your project.'}
//                                   </p>
//                                 </div>

//                                 <div className="artisan-actions">
//                                   <button
//                                     className="view-portfolio-btn"
//                                     onClick={() =>
//                                       openPortfolio(
//                                         match.artisan_id,
//                                         match.artisan_name,
//                                       )
//                                     }
//                                   >
//                                     <FaBriefcase /> View Portfolio
//                                   </button>

//                                   {match.has_proposal ? (
//                                     <>
//                                       <button
//                                         className="view-proposal-btn"
//                                         onClick={() =>
//                                           handleViewProposal(match)
//                                         }
//                                       >
//                                         <FaFileAlt /> View Proposal
//                                       </button>
//                                       <button
//                                         className="select-artisan-btn"
//                                         onClick={() =>
//                                           handleSelectArtisan(match)
//                                         }
//                                         disabled={acceptingProposal}
//                                       >
//                                         <FaCheckCircle />
//                                         {acceptingProposal
//                                           ? 'Selecting...'
//                                           : 'Select Artisan'}
//                                       </button>
//                                     </>
//                                   ) : (
//                                     <button
//                                       className="waiting-proposal-btn"
//                                       disabled
//                                     >
//                                       <FaClock /> Awaiting Proposal
//                                     </button>
//                                   )}
//                                 </div>
//                               </div>
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Rating Section for Completed Projects */}
//                     {viewRequest.status?.toLowerCase() === 'completed' && (
//                       <div className="rating-section">
//                         {existingRating ? (
//                           <div className="existing-rating">
//                             <h5>Your Review</h5>
//                             <div className="stars-display">
//                               {[...Array(5)].map((_, i) => (
//                                 <FaStar
//                                   key={i}
//                                   className="star"
//                                   color={
//                                     i < existingRating.score
//                                       ? '#ffc107'
//                                       : '#e4e5e9'
//                                   }
//                                 />
//                               ))}
//                             </div>
//                             {existingRating.review && (
//                               <div className="review-text">
//                                 <strong>Comment:</strong>{' '}
//                                 {existingRating.review}
//                               </div>
//                             )}
//                             {existingRating.images?.length > 0 && (
//                               <div className="rating-images">
//                                 <strong>Photos:</strong>
//                                 <div className="images-grid">
//                                   {existingRating.images.map((img, idx) => (
//                                     <img
//                                       key={idx}
//                                       src={img.image_url}
//                                       alt={`Review ${idx + 1}`}
//                                     />
//                                   ))}
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           <div className="new-rating">
//                             <h4>Rate Your Experience</h4>
//                             <div className="stars-rating">
//                               <label>Your Rating:</label>
//                               <div className="stars-container">
//                                 {[1, 2, 3, 4, 5].map((star) => (
//                                   <FaStar
//                                     key={star}
//                                     className={`star ${
//                                       star <= (hoverRating || rating)
//                                         ? 'active'
//                                         : ''
//                                     }`}
//                                     size={28}
//                                     onMouseEnter={() => setHoverRating(star)}
//                                     onMouseLeave={() => setHoverRating(0)}
//                                     onClick={() => setRating(star)}
//                                   />
//                                 ))}
//                               </div>
//                               <div className="rating-value">
//                                 {rating > 0
//                                   ? `You rated: ${rating} star${rating > 1 ? 's' : ''}`
//                                   : 'Click to rate'}
//                               </div>
//                             </div>

//                             <div className="review-section">
//                               <label>Your Review (Optional)</label>
//                               <textarea
//                                 placeholder="Share your experience..."
//                                 value={ratingReview}
//                                 onChange={(e) =>
//                                   setRatingReview(e.target.value)
//                                 }
//                                 className="review-textarea"
//                                 rows="3"
//                               />
//                             </div>

//                             <div className="image-upload-section">
//                               <label>Add Photos (Optional)</label>
//                               <div className="file-upload-area">
//                                 <input
//                                   type="file"
//                                   multiple
//                                   accept="image/*"
//                                   onChange={(e) =>
//                                     handleImageUpload(
//                                       e,
//                                       setRatingImages,
//                                       setRatingPreviewUrls,
//                                     )
//                                   }
//                                   className="file-input"
//                                 />
//                                 <div className="upload-hint">
//                                   <FaCamera className="upload-icon" />
//                                   <div className="upload-text">
//                                     <div className="upload-title">
//                                       Click to upload images
//                                     </div>
//                                     <div className="upload-subtitle">
//                                       PNG, JPG, WEBP up to 10MB
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>

//                               {ratingPreviewUrls.length > 0 && (
//                                 <div className="preview-images">
//                                   {ratingPreviewUrls.map((url, idx) => (
//                                     <div
//                                       key={idx}
//                                       className="preview-image-wrapper"
//                                     >
//                                       <img
//                                         src={url}
//                                         alt={`Preview ${idx + 1}`}
//                                       />
//                                       <button
//                                         type="button"
//                                         onClick={() =>
//                                           handleRemoveImage(
//                                             idx,
//                                             setRatingImages,
//                                             setRatingPreviewUrls,
//                                           )
//                                         }
//                                       >
//                                         ✖
//                                       </button>
//                                     </div>
//                                   ))}
//                                 </div>
//                               )}
//                             </div>

//                             <button
//                               className={`submit-rating-btn ${!rating ? 'disabled' : ''}`}
//                               onClick={handleSubmitRating}
//                               disabled={!rating || isSubmittingRating}
//                             >
//                               {isSubmittingRating
//                                 ? 'Submitting...'
//                                 : 'Submit Review'}
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Final Payment Banner in Modal */}
//                     {isAwaitingFinalPayment(viewRequest.status) && (
//                       <div
//                         className="final-payment-banner"
//                         style={{ marginTop: '1.5rem' }}
//                       >
//                         <div className="banner-icon">🎉</div>
//                         <div className="banner-text">
//                           <h4>Project Complete!</h4>
//                           <p>
//                             Your project is ready. Please make the final payment
//                             to complete. Amount:{' '}
//                             <strong>
//                               KSh{' '}
//                               {parseFloat(
//                                 viewRequest.agreed_cost ||
//                                   viewRequest.budget ||
//                                   0,
//                               ).toLocaleString()}
//                             </strong>
//                           </p>
//                         </div>
//                         <button
//                           className="pay-now-btn-banner"
//                           onClick={() => handlePayNow(viewRequest)}
//                           disabled={paymentLoading || finalPaymentLoading}
//                         >
//                           <FaWallet /> Pay Balance Now
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//         </Modal>

//         {/* View Proposal Modal */}
//         <Modal
//           show={showProposalModal}
//           onHide={() => {
//             setShowProposalModal(false);
//             setViewingProposal(null);
//           }}
//           centered
//           size="lg"
//           className="proposal-view-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               Proposal from {viewingProposal?.artisan_name}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {loadingProposal ? (
//               <div className="proposal-loading">
//                 <div className="spinner"></div>
//                 <p>Loading proposal details...</p>
//               </div>
//             ) : viewingProposal ? (
//               <div className="proposal-details">
//                 <div className="proposal-card">
//                   <div className="proposal-header">
//                     <div className="proposal-badge">
//                       <FaFileAlt />
//                       <span>Proposal Details</span>
//                     </div>
//                     <div
//                       className={`proposal-status ${viewingProposal.is_selected ? 'accepted' : 'pending'}`}
//                     >
//                       {viewingProposal.is_selected
//                         ? 'Accepted ✓'
//                         : 'Pending Review'}
//                     </div>
//                   </div>

//                   <div className="proposal-info-grid">
//                     <div className="info-item">
//                       <FaMoneyBillWave className="info-icon" />
//                       <div>
//                         <label>Proposed Amount</label>
//                         <p className="amount">
//                           KSh{' '}
//                           {parseFloat(
//                             viewingProposal.proposed_price || 0,
//                           ).toLocaleString()}
//                         </p>
//                       </div>
//                     </div>

//                     <div className="info-item">
//                       <FaCalendar className="info-icon" />
//                       <div>
//                         <label>Completion Date</label>
//                         <p>
//                           {viewingProposal.proposed_date_of_completion
//                             ? new Date(
//                                 viewingProposal.proposed_date_of_completion,
//                               ).toLocaleDateString()
//                             : 'Not specified'}
//                         </p>
//                       </div>
//                     </div>

//                     <div className="info-item">
//                       <FaClock className="info-icon" />
//                       <div>
//                         <label>Submitted On</label>
//                         <p>
//                           {viewingProposal.created_at
//                             ? new Date(
//                                 viewingProposal.created_at,
//                               ).toLocaleString()
//                             : 'Date not available'}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   {viewingProposal.note && (
//                     <div className="proposal-message">
//                       <label>Message from Artisan</label>
//                       <div className="message-content">
//                         <FaEnvelope className="message-icon" />
//                         <p>{viewingProposal.note}</p>
//                       </div>
//                     </div>
//                   )}

//                   {viewingProposal.is_selected && (
//                     <div className="proposal-selected-note">
//                       <FaCheckCircle />
//                       <span>
//                         This proposal has been selected for the project!
//                       </span>
//                     </div>
//                   )}

//                   {!viewingProposal.is_selected && (
//                     <div className="proposal-actions">
//                       {/* // ✅ Updated select button in View Proposal modal */}
//                       <button
//                         className="select-proposal-btn"
//                         onClick={async () => {
//                           await handleSelectArtisan({
//                             proposal_id: viewingProposal.id,
//                             artisan_name: viewingProposal.artisan_name,
//                             has_proposal: true,
//                             proposed_price: viewingProposal.proposed_price,
//                             final_agreed_amount:
//                               viewingProposal.final_agreed_amount ||
//                               viewingProposal.proposed_price,
//                           });
//                           setShowProposalModal(false);
//                           setViewingProposal(null);
//                         }}
//                         disabled={acceptingProposal}
//                       >
//                         <FaCheckCircle />
//                         {acceptingProposal
//                           ? 'Selecting...'
//                           : 'Select This Proposal'}
//                       </button>
//                       <button
//                         className="message-artisan-btn"
//                         onClick={() => {
//                           setShowProposalModal(false);
//                           setViewingProposal(null);
//                           navigate(
//                             `/messages?proposal=${viewingProposal.id}&project=${viewRequest?.title}&artisan=${viewingProposal.artisan_name}`,
//                           );
//                         }}
//                       >
//                         <FaComments /> Message Artisan
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ) : (
//               <div className="proposal-error">
//                 <FaTimes className="error-icon" />
//                 <p>Failed to load proposal details</p>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => {
//                 setShowProposalModal(false);
//                 setViewingProposal(null);
//               }}
//             >
//               Close
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Edit Modal */}
//         <Modal
//           show={!!editRequest}
//           onHide={() => setEditRequest(null)}
//           centered
//           size="lg"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Edit Project Request</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {editRequest && (
//               <div className="edit-modal-content">
//                 <form className="edit-form">
//                   <div className="form-group">
//                     <label>Project Title</label>
//                     <input
//                       type="text"
//                       value={projectData.title}
//                       onChange={(e) =>
//                         setProjectData((prev) => ({
//                           ...prev,
//                           title: e.target.value,
//                         }))
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Description</label>
//                     <textarea
//                       value={projectData.description}
//                       onChange={(e) =>
//                         setProjectData((prev) => ({
//                           ...prev,
//                           description: e.target.value,
//                         }))
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Budget (KSh)</label>
//                     <input
//                       type="number"
//                       value={projectData.budget}
//                       onChange={(e) =>
//                         setProjectData((prev) => ({
//                           ...prev,
//                           budget: e.target.value,
//                         }))
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       value={projectData.location}
//                       onChange={(e) =>
//                         setProjectData((prev) => ({
//                           ...prev,
//                           location: e.target.value,
//                         }))
//                       }
//                       required
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Preferred Deadline</label>
//                     <input
//                       type="date"
//                       value={projectData.deadline}
//                       onChange={(e) =>
//                         setProjectData((prev) => ({
//                           ...prev,
//                           deadline: e.target.value,
//                         }))
//                       }
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Upload New Images</label>
//                     <input
//                       type="file"
//                       multiple
//                       accept="image/*"
//                       onChange={(e) =>
//                         handleImageUpload(e, setNewImages, setPreviewUrls)
//                       }
//                     />
//                   </div>

//                   {previewUrls.length > 0 && (
//                     <div className="image-preview-grid-edit">
//                       {previewUrls.map((url, idx) => (
//                         <div key={idx} className="image-card edit-image">
//                           <img
//                             src={url}
//                             alt="Preview"
//                             className="thumbnail-edit-image"
//                           />
//                           <button
//                             type="button"
//                             className="remove-btn"
//                             onClick={() =>
//                               handleRemoveImage(
//                                 idx,
//                                 setNewImages,
//                                 setPreviewUrls,
//                               )
//                             }
//                           >
//                             ✖
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </form>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setEditRequest(null)}>
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={handleEditProject}>
//               Save Changes
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Delete Modal */}
//         <Modal
//           show={!!deleteRequest}
//           onHide={() => setDeleteRequest(null)}
//           centered
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Delete Request</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {deleteRequest && (
//               <p>
//                 Are you sure you want to delete{' '}
//                 <strong>{deleteRequest.title}</strong>?
//               </p>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setDeleteRequest(null)}>
//               Cancel
//             </Button>
//             <Button variant="danger" onClick={handleDeleteProject}>
//               Delete
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Portfolio Modal */}
//         <Modal
//           show={!!portfolioModal}
//           onHide={closePortfolio}
//           centered
//           size="xl"
//           className="portfolio-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {portfolioModal?.artisan_name}'s Portfolio
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="portfolio-content">
//               <div className="artisan-profile">
//                 <div className="profile-header">
//                   <div className="artisan-avatar">
//                     <img
//                       src={portfolioModal?.artisan_avatar}
//                       alt={portfolioModal?.artisan_name}
//                     />
//                   </div>
//                   <div className="profile-info">
//                     <h3>{portfolioModal?.artisan_name}</h3>
//                     <div className="rating-display">
//                       <div className="stars">
//                         {[...Array(5)].map((_, i) => (
//                           <FaStar
//                             key={i}
//                             className="star"
//                             color={
//                               i < Math.round(portfolioModal?.client_rating || 0)
//                                 ? '#ffc107'
//                                 : '#e4e5e9'
//                             }
//                           />
//                         ))}
//                       </div>
//                       <span className="rating-text">
//                         {portfolioModal?.client_rating || '0'}/5
//                       </span>
//                     </div>
//                     <span className="specialization">
//                       {portfolioModal?.specialization || 'Furniture Artisan'}
//                     </span>
//                   </div>
//                 </div>
//                 <div className="artisan-bio">
//                   <p
//                     className={`bio-content ${expandedBios[portfolioModal?.artisan_id] ? 'expanded' : 'collapsed'}`}
//                   >
//                     {portfolioModal?.bio || 'No bio available'}
//                   </p>
//                   <button
//                     className={`read-more-btn ${expandedBios[portfolioModal?.artisan_id] ? 'expanded' : ''}`}
//                     onClick={() => toggleBio(portfolioModal?.artisan_id)}
//                   >
//                     {expandedBios[portfolioModal?.artisan_id]
//                       ? 'Read Less'
//                       : 'Read More'}
//                   </button>
//                 </div>
//               </div>

//               <div className="portfolio-stats">
//                 <div className="stat-card">
//                   <div className="stat-number">
//                     {portfolioModal?.projects_completed || '0'}
//                   </div>
//                   <div className="stat-label">Projects Completed</div>
//                 </div>
//                 <div className="stat-card">
//                   <div className="stat-number">
//                     {portfolioModal?.years_of_experience || '0'}+
//                   </div>
//                   <div className="stat-label">Years Experience</div>
//                 </div>
//               </div>

//               <div className="portfolio-projects-section">
//                 <div className="section-title">
//                   <h4>Featured Projects</h4>
//                   <p>Explore the artisan's completed work and craftsmanship</p>
//                 </div>
//                 {portfolioModal?.portfolio_items?.length > 0 ? (
//                   <div className="projects-grid">
//                     {portfolioModal.portfolio_items.map((project) => (
//                       <div key={project.id} className="portfolio-project-card">
//                         <div className="carousel-container">
//                           {project.images?.length > 0 ? (
//                             <div className="carousel-wrapper">
//                               {project.images?.map((img, index) => (
//                                 <img
//                                   key={img.id}
//                                   src={img.image}
//                                   alt={`${project.title} ${index + 1}`}
//                                   className={`carousel-image ${
//                                     index === (carouselIndex[project.id] || 0)
//                                       ? 'active-image'
//                                       : 'inactive-image'
//                                   }`}
//                                 />
//                               ))}
//                             </div>
//                           ) : (
//                             <div className="image-placeholder">
//                               <FaImage className="placeholder-icon" />
//                               <span className="placeholder-text">
//                                 No images available
//                               </span>
//                             </div>
//                           )}
//                           <button
//                             className="carousel-btn left"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handlePrev(project.id, project.images.length);
//                             }}
//                           >
//                             ‹
//                           </button>
//                           <button
//                             className="carousel-btn right"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleNext(project.id, project.images.length);
//                             }}
//                           >
//                             ›
//                           </button>
//                           {project.images?.length > 1 && (
//                             <div className="carousel-indicators">
//                               {project.images.map((_, index) => (
//                                 <div
//                                   key={index}
//                                   className={`indicator ${
//                                     index === (carouselIndex[project.id] || 0)
//                                       ? 'active'
//                                       : ''
//                                   }`}
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     setCarouselIndex((prev) => ({
//                                       ...prev,
//                                       [project.id]: index,
//                                     }));
//                                   }}
//                                 />
//                               ))}
//                             </div>
//                           )}
//                         </div>
//                         <div className="project-info">
//                           <h5>{project.title}</h5>
//                           <div className="project-description">
//                             <p
//                               className={`description-content ${
//                                 expandedDescriptions[project.id]
//                                   ? 'expanded'
//                                   : 'collapsed'
//                               }`}
//                             >
//                               {project.description}
//                             </p>
//                             {project.description &&
//                               project.description.length > 100 && (
//                                 <button
//                                   className={`read-more-btn ${
//                                     expandedDescriptions[project.id]
//                                       ? 'expanded'
//                                       : ''
//                                   }`}
//                                   onClick={() => toggleDescription(project.id)}
//                                 >
//                                   {expandedDescriptions[project.id]
//                                     ? 'Read Less'
//                                     : 'Read More'}
//                                 </button>
//                               )}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="portfolio-empty-state">
//                     <div className="empty-icon">🎨</div>
//                     <h4>No Projects Yet</h4>
//                     <p>
//                       This artisan hasn't added any projects to their portfolio
//                       yet.
//                     </p>
//                   </div>
//                 )}
//               </div>

//               <div className="skills-section">
//                 <h5>Specializations & Skills</h5>
//                 <div className="skills-grid">
//                   {portfolioModal?.skills?.length > 0 ? (
//                     portfolioModal.skills.map((skill, index) => (
//                       <span key={index} className="skill-tag">
//                         {skill}
//                       </span>
//                     ))
//                   ) : (
//                     <>
//                       <span className="skill-tag">Woodworking</span>
//                       <span className="skill-tag">Custom Furniture</span>
//                       <span className="skill-tag">Carpentry</span>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={closePortfolio}>
//               Close Portfolio
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* Confirmation Modal for Selecting Artisan */}
//         <Modal
//           show={showConfirmModal}
//           onHide={() => {
//             setShowConfirmModal(false);
//             setSelectedMatchForConfirm(null);
//           }}
//           centered
//           className="confirm-select-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Confirm Artisan Selection</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {selectedMatchForConfirm && (
//               <div className="confirmation-content">
//                 <div className="confirmation-icon">
//                   <FaCheckCircle className="warning-icon" />
//                 </div>
//                 <p className="confirmation-question">
//                   Are you sure you want to select{' '}
//                   <strong>{selectedMatchForConfirm.artisan_name}</strong> for
//                   this project?
//                 </p>

//                 <div className="confirmation-details">
//                   <div className="detail-row">
//                     <span className="detail-label">Project:</span>
//                     <span className="detail-value">{viewRequest?.title}</span>
//                   </div>
//                   <div className="detail-row">
//                     <span className="detail-label">Artisan:</span>
//                     <span className="detail-value">
//                       {selectedMatchForConfirm.artisan_name}
//                     </span>
//                   </div>
//                   <div className="detail-row highlight">
//                     <span className="detail-label">Agreed Amount:</span>
//                     <span className="detail-value amount">
//                       KSh{' '}
//                       {selectedMatchForConfirm.final_agreed_amount
//                         ? parseFloat(
//                             selectedMatchForConfirm.final_agreed_amount,
//                           ).toLocaleString()
//                         : parseFloat(
//                             selectedMatchForConfirm.proposed_price,
//                           ).toLocaleString()}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="confirmation-warning">
//                   <p>
//                     ⚠️ <strong>Note:</strong> Once you select this artisan:
//                   </p>
//                   <ul>
//                     <li>
//                       Other proposals for this project will be automatically
//                       declined
//                     </li>
//                     <li>The artisan will be notified and project will start</li>
//                     <li>
//                       You will be able to communicate with the artisan through
//                       messages
//                     </li>
//                     <li>This action cannot be undone</li>
//                   </ul>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => {
//                 setShowConfirmModal(false);
//                 setSelectedMatchForConfirm(null);
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={confirmSelectArtisan}
//               disabled={acceptingProposal}
//               className="confirm-select-btn"
//             >
//               {acceptingProposal ? (
//                 <>
//                   <FaSpinner className="spinning" /> Selecting...
//                 </>
//               ) : (
//                 <>
//                   <FaCheckCircle /> Yes, Select Artisan
//                 </>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* ========== DEPOSIT PAYMENT MODAL ========== */}
//         <Modal
//           show={showPaymentModal}
//           onHide={() => {
//             setShowPaymentModal(false);
//             setSelectedProjectForPayment(null);
//           }}
//           centered
//           size="lg"
//           className="payment-modal-modern"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               <FaWallet className="modal-title-icon" />
//               Pay Deposit
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {selectedProjectForPayment && (
//               <div className="payment-content-modern">
//                 {/* Project Summary */}
//                 <div className="payment-summary-modern">
//                   <h4>📋 Project Summary</h4>
//                   <div className="summary-details-modern">
//                     <div className="summary-row-modern">
//                       <span className="summary-label">Project:</span>
//                       <strong className="summary-value">
//                         {selectedProjectForPayment.title}
//                       </strong>
//                     </div>
//                     <div className="summary-row-modern">
//                       <span className="summary-label">Artisan:</span>
//                       <strong className="summary-value">
//                         {selectedProjectForPayment.artisan_name}
//                       </strong>
//                     </div>
//                     <div className="summary-row-modern highlight-row">
//                       <span className="summary-label">Total Amount:</span>
//                       <strong className="summary-value amount-value">
//                         KSh{' '}
//                         {selectedProjectForPayment.agreed_cost.toLocaleString()}
//                       </strong>
//                     </div>
//                     <div className="summary-row-modern">
//                       <span className="summary-label">Deposit (50%):</span>
//                       <strong className="summary-value">
//                         KSh{' '}
//                         {(
//                           selectedProjectForPayment.agreed_cost * 0.5
//                         ).toLocaleString()}
//                       </strong>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Payment Methods */}
//                 {/* <div className="payment-methods-modern">
//                   <h5>Payment Methods</h5>
//                   <div className="payment-methods-grid-modern">
//                     <div
//                       className={`payment-method-modern ${paymentMethod === 'mpesa' ? 'selected' : ''}`}
//                       onClick={() => setPaymentMethod('mpesa')}
//                     >
//                       <FaMobileAlt className="method-icon" />
//                       <span>M-Pesa</span>
//                     </div>
//                     <div
//                       className={`payment-method-modern ${paymentMethod === 'card' ? 'selected' : ''}`}
//                       onClick={() => setPaymentMethod('card')}
//                     >
//                       <FaCreditCard className="method-icon" />
//                       <span>Card</span>
//                     </div>
//                     <div
//                       className={`payment-method-modern ${paymentMethod === 'bank' ? 'selected' : ''}`}
//                       onClick={() => setPaymentMethod('bank')}
//                     >
//                       <FaUniversity className="method-icon" />
//                       <span>Bank Transfer</span>
//                     </div>
//                   </div>
//                   <p className="payment-note-modern">
//                     🔒 You will be redirected to Paystack to complete your
//                     payment securely.
//                   </p>
//                 </div> */}

//                 {/* Payment Breakdown */}
//                 <div className="payment-breakdown-modern">
//                   <h6>Payment Breakdown</h6>
//                   <div className="breakdown-row">
//                     <span>Total Project Cost</span>
//                     <span>
//                       KSh{' '}
//                       {selectedProjectForPayment.agreed_cost.toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="breakdown-row">
//                     <span>Deposit (50%)</span>
//                     <span className="breakdown-type">
//                       KSh{' '}
//                       {(
//                         selectedProjectForPayment.agreed_cost * 0.5
//                       ).toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="breakdown-row total">
//                     <span>Total to Pay</span>
//                     <span className="total-amount">
//                       KSh{' '}
//                       {(
//                         selectedProjectForPayment.agreed_cost * 0.5
//                       ).toLocaleString()}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => {
//                 setShowPaymentModal(false);
//                 setSelectedProjectForPayment(null);
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={() => {
//                 if (selectedProjectForPayment) {
//                   initializeDepositPayment(
//                     selectedProjectForPayment.proposal_id,
//                   );
//                 }
//               }}
//               disabled={paymentLoading}
//               className="pay-now-btn-modern"
//             >
//               {paymentLoading ? (
//                 <>
//                   <FaSpinner className="spinning" /> Processing...
//                 </>
//               ) : (
//                 <>
//                   <FaWallet />
//                   Pay Deposit
//                 </>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* ========== FINAL PAYMENT MODAL ========== */}
//         <Modal
//           show={showFinalPaymentModal}
//           onHide={() => {
//             setShowFinalPaymentModal(false);
//             setSelectedProjectForFinalPayment(null);
//           }}
//           centered
//           size="lg"
//           className="payment-modal-modern final-payment-modal"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               <FaWallet className="modal-title-icon" />
//               Final Payment
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {selectedProjectForFinalPayment && (
//               <div className="payment-content-modern">
//                 {/* Project Summary */}
//                 <div className="payment-summary-modern">
//                   <h4>📋 Project Summary</h4>
//                   <div className="summary-details-modern">
//                     <div className="summary-row-modern">
//                       <span className="summary-label">Project:</span>
//                       <strong className="summary-value">
//                         {selectedProjectForFinalPayment.title}
//                       </strong>
//                     </div>
//                     <div className="summary-row-modern">
//                       <span className="summary-label">Artisan:</span>
//                       <strong className="summary-value">
//                         {selectedProjectForFinalPayment.artisan_name}
//                       </strong>
//                     </div>
//                     <div className="summary-row-modern highlight-row">
//                       <span className="summary-label">Remaining Balance:</span>
//                       <strong className="summary-value amount-value">
//                         KSh{' '}
//                         {(
//                           selectedProjectForFinalPayment.agreed_cost * 0.5
//                         ).toLocaleString()}
//                       </strong>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Payment Methods */}
//                 {/* <div className="payment-methods-modern">
//                   <h5>Payment Methods</h5>
//                   <div className="payment-methods-grid-modern">
//                     <div
//                       className={`payment-method-modern ${paymentMethod === 'mpesa' ? 'selected' : ''}`}
//                       onClick={() => setPaymentMethod('mpesa')}
//                     >
//                       <FaMobileAlt className="method-icon" />
//                       <span>M-Pesa</span>
//                     </div>
//                     <div
//                       className={`payment-method-modern ${paymentMethod === 'card' ? 'selected' : ''}`}
//                       onClick={() => setPaymentMethod('card')}
//                     >
//                       <FaCreditCard className="method-icon" />
//                       <span>Card</span>
//                     </div>
//                     <div
//                       className={`payment-method-modern ${paymentMethod === 'bank' ? 'selected' : ''}`}
//                       onClick={() => setPaymentMethod('bank')}
//                     >
//                       <FaUniversity className="method-icon" />
//                       <span>Bank Transfer</span>
//                     </div>
//                   </div>
//                   <p className="payment-note-modern">
//                     🔒 You will be redirected to Paystack to complete your
//                     final payment securely.
//                   </p>
//                 </div> */}

//                 {/* Payment Breakdown */}
//                 <div className="payment-breakdown-modern">
//                   <h6>Payment Breakdown</h6>
//                   <div className="breakdown-row">
//                     <span>Total Project Cost</span>
//                     <span>
//                       KSh{' '}
//                       {selectedProjectForFinalPayment.agreed_cost.toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="breakdown-row">
//                     <span>Deposit Paid</span>
//                     <span className="breakdown-type">
//                       KSh{' '}
//                       {(
//                         selectedProjectForFinalPayment.agreed_cost * 0.5
//                       ).toLocaleString()}
//                     </span>
//                   </div>
//                   <div className="breakdown-row total">
//                     <span>Final Payment</span>
//                     <span className="total-amount">
//                       KSh{' '}
//                       {(
//                         selectedProjectForFinalPayment.agreed_cost * 0.5
//                       ).toLocaleString()}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => {
//                 setShowFinalPaymentModal(false);
//                 setSelectedProjectForFinalPayment(null);
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={() => {
//                 if (selectedProjectForFinalPayment) {
//                   initializeFinalPayment(
//                     selectedProjectForFinalPayment.proposal_id,
//                   );
//                 }
//               }}
//               disabled={finalPaymentLoading}
//               className="pay-now-btn-modern final-payment-btn"
//             >
//               {finalPaymentLoading ? (
//                 <>
//                   <FaSpinner className="spinning" /> Processing...
//                 </>
//               ) : (
//                 <>
//                   <FaWallet />
//                   Complete Final Payment
//                 </>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(MyRequests, 'client');

// src/pages/buyer/my-requests/MyRequests.jsx

import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';
import {
  FaStar,
  FaCamera,
  FaImage,
  FaUserCircle,
  FaBriefcase,
  FaCheckCircle,
  FaClock,
  FaFileAlt,
  FaTimes,
  FaMoneyBillWave,
  FaCalendar,
  FaEnvelope,
  FaComments,
  FaSpinner,
  FaRocket,
  FaProjectDiagram,
  FaHandshake,
  FaWallet,
  FaCreditCard,
  FaMobileAlt,
  FaUniversity,
  FaCheck,
} from 'react-icons/fa';
import './myrequests.scss';
import FurnitureNavbar from '../../../components/layout/Nav';

const MyRequests = () => {
  // ========== STATE MANAGEMENT ==========
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [matchedArtisans, setMatchedArtisans] = useState([]);
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [viewRequest, setViewRequest] = useState(null);
  const [editRequest, setEditRequest] = useState(null);
  const [deleteRequest, setDeleteRequest] = useState(null);
  const [portfolioModal, setPortfolioModal] = useState(null);
  const [showProposalModal, setShowProposalModal] = useState(false);
  const [viewingProposal, setViewingProposal] = useState(null);
  const [loadingProposal, setLoadingProposal] = useState(false);
  const [acceptingProposal, setAcceptingProposal] = useState(false);
  const [autoOpenProjectId, setAutoOpenProjectId] = useState(null);
  const [showPriceAgreedMessage, setShowPriceAgreedMessage] = useState(false);
  const [selectedArtisanId, setSelectedArtisanId] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [ratingReview, setRatingReview] = useState('');
  const [ratingImages, setRatingImages] = useState([]);
  const [ratingPreviewUrls, setRatingPreviewUrls] = useState([]);
  const [existingRating, setExistingRating] = useState(null);
  const [isSubmittingRating, setIsSubmittingRating] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [carouselIndex, setCarouselIndex] = useState({});
  const [expandedBios, setExpandedBios] = useState({});
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedMatchForConfirm, setSelectedMatchForConfirm] = useState(null);
  const [cameraLoading, setCameraLoading] = useState(false);
  const [projectData, setProjectData] = useState({
    title: '',
    description: '',
    budget: '',
    location: '',
    deadline: '',
  });
  const [newImages, setNewImages] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);

  // ========== CAMERA STATE MANAGEMENT ==========
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  // ========== PAYMENT STATE MANAGEMENT ==========
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedProjectForPayment, setSelectedProjectForPayment] =
    useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [paymentType, setPaymentType] = useState('deposit');
  const [paymentMethod, setPaymentMethod] = useState('mpesa');

  // ========== FINAL PAYMENT STATE MANAGEMENT ==========
  const [showFinalPaymentModal, setShowFinalPaymentModal] = useState(false);
  const [selectedProjectForFinalPayment, setSelectedProjectForFinalPayment] =
    useState(null);
  const [finalPaymentLoading, setFinalPaymentLoading] = useState(false);

  const navigate = useNavigate();

  // ========== CAMERA FUNCTIONS ==========
  // ========== CAMERA FUNCTIONS ==========
  const startCamera = async () => {
    try {
      console.log('📷 Starting camera...');

      // Check if browser supports getUserMedia
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        toast.error('Your browser does not support camera access');
        return;
      }

      // Request camera with specific constraints
      const constraints = {
        video: {
          facingMode: 'environment',
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
        audio: false,
      };

      console.log('Requesting camera with constraints:', constraints);

      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      console.log('✅ Camera stream obtained:', stream);

      setCameraStream(stream);

      // Wait for the video element to be available
      setTimeout(() => {
        if (videoRef.current) {
          console.log('🎥 Setting video source...');
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            console.log('📹 Video metadata loaded, playing...');
            videoRef.current
              .play()
              .then(() => {
                console.log('▶️ Video playing successfully');
              })
              .catch((err) => {
                console.error('❌ Error playing video:', err);
                toast.error('Failed to play video stream');
              });
          };
          videoRef.current.onerror = (err) => {
            console.error('❌ Video element error:', err);
            toast.error('Video stream error');
          };
        } else {
          console.error('❌ Video ref is null');
        }
      }, 100);

      setShowCameraModal(true);
      setCapturedPhoto(null);
    } catch (err) {
      console.error('❌ Error accessing camera:', err);

      if (
        err.name === 'NotAllowedError' ||
        err.name === 'PermissionDeniedError'
      ) {
        toast.error(
          'Camera access denied. Please allow camera permissions in your browser settings.',
        );
      } else if (
        err.name === 'NotFoundError' ||
        err.name === 'DevicesNotFoundError'
      ) {
        toast.error(
          'No camera found on this device. Please connect a camera and try again.',
        );
      } else if (
        err.name === 'NotReadableError' ||
        err.name === 'TrackStartError'
      ) {
        toast.error(
          'Camera is busy or not readable. Please close other apps using the camera.',
        );
      } else if (err.name === 'OverconstrainedError') {
        toast.error(
          'Camera constraints cannot be met. Trying with default settings...',
        );
        // Retry with basic constraints
        try {
          const basicStream = await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: false,
          });
          setCameraStream(basicStream);
          if (videoRef.current) {
            videoRef.current.srcObject = basicStream;
            await videoRef.current.play();
          }
          setShowCameraModal(true);
          setCapturedPhoto(null);
          return;
        } catch (retryErr) {
          toast.error('Failed to access camera with default settings');
        }
      } else {
        toast.error(`Failed to open camera: ${err.message || 'Unknown error'}`);
      }
    }
  };

  const stopCamera = () => {
    console.log('🛑 Stopping camera...');
    if (cameraStream) {
      cameraStream.getTracks().forEach((track) => {
        track.stop();
        console.log(`Track ${track.kind} stopped`);
      });
      setCameraStream(null);
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
      console.log('Video source cleared');
    }
  };

  const capturePhoto = () => {
    console.log('📸 Capturing photo...');
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;

      // Set canvas to video dimensions
      const videoWidth = video.videoWidth || 640;
      const videoHeight = video.videoHeight || 480;

      console.log(`Video dimensions: ${videoWidth}x${videoHeight}`);

      canvas.width = videoWidth;
      canvas.height = videoHeight;

      const context = canvas.getContext('2d');
      // Draw the current video frame
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert to blob
      canvas.toBlob(
        (blob) => {
          if (blob) {
            console.log(`📷 Photo captured: ${blob.size} bytes`);
            const file = new File([blob], `review-photo-${Date.now()}.jpg`, {
              type: 'image/jpeg',
            });
            const previewUrl = URL.createObjectURL(blob);

            setCapturedPhoto({
              file: file,
              previewUrl: previewUrl,
            });

            // Pause the video while showing preview
            video.pause();
          } else {
            console.error('❌ Failed to create blob from canvas');
            toast.error('Failed to capture photo');
          }
        },
        'image/jpeg',
        0.9,
      );
    } else {
      console.error('❌ Video or canvas ref is null');
      toast.error('Camera not ready. Please wait a moment.');
    }
  };

  const retakePhoto = () => {
    console.log('🔄 Retaking photo...');
    setCapturedPhoto(null);
    if (videoRef.current) {
      videoRef.current
        .play()
        .then(() => {
          console.log('▶️ Video resumed for retake');
        })
        .catch((err) => {
          console.error('❌ Error resuming video:', err);
        });
    }
  };

  const saveCapturedPhoto = () => {
    if (capturedPhoto) {
      console.log('💾 Saving captured photo...');
      setRatingImages((prev) => [...prev, capturedPhoto.file]);
      setRatingPreviewUrls((prev) => [...prev, capturedPhoto.previewUrl]);
      setShowCameraModal(false);
      setCapturedPhoto(null);
      stopCamera();
      toast.success('📸 Photo captured successfully!');
    }
  };

  // ========== UI HELPERS ==========
  const shouldShowEditDelete = (status) =>
    ['open', 'pending'].includes(status?.toLowerCase());

  const isPaymentPending = (status) =>
    ['awaiting deposit payment', 'pending payment', 'payment pending'].some(
      (s) => status?.toLowerCase().includes(s),
    );

  const shouldShowPayButton = (status) => {
    if (!status) return false;
    const lowerStatus = status.toLowerCase();
    return (
      lowerStatus === 'awaiting deposit payment' ||
      lowerStatus === 'awaiting-final-payment' ||
      lowerStatus === 'awaiting final payment' ||
      lowerStatus === 'pending payment' ||
      lowerStatus === 'payment pending' ||
      lowerStatus === 'awaiting payment'
    );
  };

  const isAwaitingFinalPayment = (status) => {
    return (
      status?.toLowerCase() === 'awaiting-final-payment' ||
      status?.toLowerCase() === 'awaiting final payment'
    );
  };

  const normalize = (str) => str?.toLowerCase().replace(/\s+/g, '');

  const filteredRequests =
    filter === 'all'
      ? requests
      : requests.filter((r) => normalize(r.status) === normalize(filter));

  // ========== API FUNCTIONS ==========
  const fetchClientProjects = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await serverUrlAuth.get('projects/client-projects/');
      setRequests(res.data);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to fetch project requests.');
    } finally {
      setLoading(false);
    }
  };

  const fetchMatchedArtisans = async (projectId) => {
    setLoadingMatches(true);
    try {
      const res = await serverUrlAuth.get(
        `projects/client/projects/${projectId}/matches/`,
      );
      console.log('Matched artisans response:', res.data);

      // Sort artisans: those with proposals first
      const sortedArtisans = res.data.sort((a, b) => {
        const aHasProposal = a.has_proposal === true;
        const bHasProposal = b.has_proposal === true;

        if (aHasProposal && !bHasProposal) return -1;
        if (!aHasProposal && bHasProposal) return 1;

        if (aHasProposal && bHasProposal) {
          const aSelected = a.proposal_selected === true;
          const bSelected = b.proposal_selected === true;
          if (aSelected && !bSelected) return -1;
          if (!aSelected && bSelected) return 1;
        }

        const aRating = parseFloat(a.average_rating) || 0;
        const bRating = parseFloat(b.average_rating) || 0;
        if (aRating !== bRating) return bRating - aRating;

        return (a.artisan_name || '').localeCompare(b.artisan_name || '');
      });

      setMatchedArtisans(sortedArtisans);
    } catch (err) {
      console.error('Error fetching matched artisans:', err);
      toast.error('Failed to load matched artisans');
    } finally {
      setLoadingMatches(false);
    }
  };

  const fetchProposalDetails = async (proposalId) => {
    setLoadingProposal(true);
    try {
      const response = await serverUrlAuth.get(
        `proposals/proposal-detail/${proposalId}/`,
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching proposal details:', error);
      toast.error('Failed to load proposal details');
      return null;
    } finally {
      setLoadingProposal(false);
    }
  };

  const fetchPortfolioData = async (artisanId) => {
    try {
      const response = await serverUrlAuth.get(
        `portfolio/artisan-portfolio/${artisanId}/`,
      );
      return response.data;
    } catch (err) {
      console.error('Error fetching portfolio:', err);
    }
  };

  const fetchRating = async () => {
    if (!viewRequest?.id) return;
    try {
      const res = await serverUrlAuth.get(
        `reviews/project-review/${viewRequest.id}/`,
      );
      if (res.data) {
        setExistingRating(res.data);
        setRating(res.data.score || 0);
        setRatingReview(res.data.review || '');
        setRatingPreviewUrls(
          res.data.images?.map((img) => img.image_url) || [],
        );
      }
    } catch (err) {
      if (err.response?.status !== 404) {
        toast.error('Failed to fetch rating');
      }
    }
  };

  // ========== PAYMENT HANDLERS ==========
  const handlePayNow = async (project) => {
    setPaymentLoading(true);
    try {
      let proposalId = null;
      let artisanId = null;
      let artisanName = 'Artisan';

      console.log('🔍 Handling payment for project:', project.id);

      if (matchedArtisans.length > 0) {
        console.log('Looking for proposal in matched artisans...');
        const matchedArtisan = matchedArtisans.find(
          (m) => m.proposal_selected === true || m.has_proposal === true,
        );
        if (matchedArtisan) {
          proposalId = matchedArtisan.proposal_id;
          artisanId = matchedArtisan.artisan_id;
          artisanName = matchedArtisan.artisan_name || 'Artisan';
          console.log('✅ Found proposal in matched artisans:', proposalId);
        }
      }

      if (!proposalId) {
        console.log('Fetching proposals for project:', project.id);
        try {
          const proposalsResponse = await serverUrlAuth.get(
            `proposals/proposals-list/${project.id}/`,
          );
          const proposals = proposalsResponse.data;

          console.log('📋 Proposals found:', proposals.length);

          if (proposals && proposals.length > 0) {
            const selectedProposal =
              proposals.find((p) => p.is_selected === true) || proposals[0];
            proposalId = selectedProposal.id;
            artisanId =
              selectedProposal.artisan_id || selectedProposal.artisan?.id;
            artisanName =
              selectedProposal.artisan_name ||
              selectedProposal.artisan?.name ||
              'Artisan';
            console.log('✅ Found proposal from API:', proposalId);
          }
        } catch (error) {
          console.error('Error fetching proposals:', error);
          toast.error('Unable to fetch proposal details');
          setPaymentLoading(false);
          return;
        }
      }

      if (!proposalId) {
        toast.error(
          'No proposal found for this project. Please contact support.',
        );
        setPaymentLoading(false);
        return;
      }

      const agreedAmount = project.agreed_cost || project.budget || 0;

      if (isAwaitingFinalPayment(project.status)) {
        setSelectedProjectForFinalPayment({
          id: project.id,
          proposal_id: proposalId,
          title: project.title,
          artisan_name: artisanName,
          artisan_id: artisanId,
          agreed_cost: parseFloat(agreedAmount),
          budget: parseFloat(project.budget || 0),
        });
        setShowFinalPaymentModal(true);
        setViewRequest(null);
        setPaymentLoading(false);
        return;
      }

      setSelectedProjectForPayment({
        id: project.id,
        proposal_id: proposalId,
        title: project.title,
        artisan_name: artisanName,
        artisan_id: artisanId,
        agreed_cost: parseFloat(agreedAmount),
        budget: parseFloat(project.budget || 0),
      });

      setPaymentType('deposit');
      setShowPaymentModal(true);
      setViewRequest(null);
    } catch (error) {
      console.error('Error initializing payment:', error);
      toast.error('Failed to initialize payment. Please try again.');
    } finally {
      setPaymentLoading(false);
    }
  };

  // ========== DEPOSIT PAYMENT ==========
  const initializeDepositPayment = async (proposalId) => {
    setPaymentLoading(true);
    try {
      if (!proposalId) {
        toast.error('Proposal ID is required');
        setPaymentLoading(false);
        return;
      }

      const payload = {
        proposal_id: proposalId,
        payment_type: 'deposit',
      };

      console.log('📤 Sending deposit payment payload:', payload);

      const response = await serverUrlAuth.post(
        'payments/initialize/',
        payload,
      );

      console.log('📥 Payment response:', response.data);

      if (response.data.status === true) {
        setPaymentData(response.data);

        const {
          authorization_url,
          reference,
          access_code,
          amount,
          payment_type: responsePaymentType,
        } = response.data;

        sessionStorage.setItem('currentPaymentReference', reference);
        sessionStorage.setItem(
          'currentProjectId',
          selectedProjectForPayment?.id || '',
        );
        sessionStorage.setItem('currentPaymentAmount', amount);
        sessionStorage.setItem('currentPaymentType', responsePaymentType);

        toast.success(
          `Deposit payment initialized! Amount: KSh ${parseFloat(amount).toLocaleString()}`,
        );

        const paymentWindow = window.open(
          authorization_url,
          '_blank',
          'noopener,noreferrer',
        );

        if (
          !paymentWindow ||
          paymentWindow.closed ||
          typeof paymentWindow.closed === 'undefined'
        ) {
          toast.warning('Popup blocked! Please allow popups for this site.');
          toast.info(
            <div>
              Click here to complete payment:
              <a
                href={authorization_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {authorization_url}
              </a>
            </div>,
            { autoClose: 15000 },
          );
        }

        setShowPaymentModal(false);
        setSelectedProjectForPayment(null);

        toast.info(
          '💳 Complete payment in the Paystack window. Your project will update automatically after payment.',
          { autoClose: 10000 },
        );

        startPaymentPolling(reference);
      } else {
        const errorMessage =
          response.data.message || 'Payment initialization failed';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('❌ Payment initialization error:', error);
      console.error('Error response:', error.response?.data);

      let errorMessage = 'Failed to initialize payment. Please try again.';

      if (error.response) {
        const data = error.response.data;
        if (data.message) errorMessage = data.message;
        else if (data.detail) errorMessage = data.detail;
        else if (data.error) errorMessage = data.error;

        if (data.errors) {
          const errorList = Object.values(data.errors).flat().join(', ');
          errorMessage = `Validation error: ${errorList}`;
        }

        if (error.response.status === 400) {
          errorMessage =
            'Invalid request. Please check the proposal ID and payment type.';
        } else if (error.response.status === 401) {
          errorMessage = 'Authentication error. Please login again.';
        } else if (error.response.status === 403) {
          errorMessage = 'You do not have permission to make this payment.';
        } else if (error.response.status === 404) {
          errorMessage = 'Proposal not found. Please try again.';
        } else if (error.response.status === 500) {
          errorMessage = 'Server error. Please try again later.';
        }
      } else if (error.request) {
        errorMessage =
          'No response from server. Please check your internet connection.';
      }

      toast.error(errorMessage);
    } finally {
      setPaymentLoading(false);
    }
  };

  // ========== FINAL PAYMENT ==========
  const initializeFinalPayment = async (proposalId) => {
    setFinalPaymentLoading(true);
    try {
      if (!proposalId) {
        toast.error('Proposal ID is required');
        setFinalPaymentLoading(false);
        return;
      }

      const payload = {
        proposal_id: proposalId,
        payment_type: 'balance',
      };

      console.log('📤 Sending final payment payload:', payload);

      const response = await serverUrlAuth.post(
        'payments/initialize/',
        payload,
      );

      console.log('📥 Payment response:', response.data);

      if (response.data.status === true) {
        setPaymentData(response.data);

        const {
          authorization_url,
          reference,
          access_code,
          amount,
          payment_type: responsePaymentType,
        } = response.data;

        sessionStorage.setItem('currentPaymentReference', reference);
        sessionStorage.setItem(
          'currentProjectId',
          selectedProjectForFinalPayment?.id || '',
        );
        sessionStorage.setItem('currentPaymentAmount', amount);
        sessionStorage.setItem('currentPaymentType', responsePaymentType);

        toast.success(
          `Final payment initialized! Amount: KSh ${parseFloat(amount).toLocaleString()}`,
        );

        const paymentWindow = window.open(
          authorization_url,
          '_blank',
          'noopener,noreferrer',
        );

        if (
          !paymentWindow ||
          paymentWindow.closed ||
          typeof paymentWindow.closed === 'undefined'
        ) {
          toast.warning('Popup blocked! Please allow popups for this site.');
          toast.info(
            <div>
              Click here to complete payment:
              <a
                href={authorization_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {authorization_url}
              </a>
            </div>,
            { autoClose: 15000 },
          );
        }

        setShowFinalPaymentModal(false);
        setSelectedProjectForFinalPayment(null);

        toast.info(
          '💳 Complete payment in the Paystack window. Your project will be marked as completed after payment.',
          { autoClose: 10000 },
        );

        startPaymentPolling(reference);
      } else {
        const errorMessage =
          response.data.message || 'Payment initialization failed';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('❌ Final payment initialization error:', error);
      console.error('Error response:', error.response?.data);

      let errorMessage =
        'Failed to initialize final payment. Please try again.';

      if (error.response) {
        const data = error.response.data;
        if (data.message) errorMessage = data.message;
        else if (data.detail) errorMessage = data.detail;
        else if (data.error) errorMessage = data.error;

        if (data.errors) {
          const errorList = Object.values(data.errors).flat().join(', ');
          errorMessage = `Validation error: ${errorList}`;
        }

        if (error.response.status === 400) {
          errorMessage =
            'Invalid request. Please check the proposal ID and payment type.';
        } else if (error.response.status === 401) {
          errorMessage = 'Authentication error. Please login again.';
        } else if (error.response.status === 403) {
          errorMessage = 'You do not have permission to make this payment.';
        } else if (error.response.status === 404) {
          errorMessage = 'Proposal not found. Please try again.';
        } else if (error.response.status === 500) {
          errorMessage = 'Server error. Please try again later.';
        }
      } else if (error.request) {
        errorMessage =
          'No response from server. Please check your internet connection.';
      }

      toast.error(errorMessage);
    } finally {
      setFinalPaymentLoading(false);
    }
  };

  const startPaymentPolling = (reference) => {
    let attempts = 0;
    const maxAttempts = 60;
    const intervalId = setInterval(async () => {
      attempts++;
      console.log(
        `🔍 Checking payment status (Attempt ${attempts}/${maxAttempts})...`,
      );

      try {
        const projectId = sessionStorage.getItem('currentProjectId');

        if (!projectId) {
          console.log('No project ID found, stopping polling');
          clearInterval(intervalId);
          return;
        }

        const response = await serverUrlAuth.get(
          `projects/client-project/${projectId}/`,
        );
        const project = response.data;

        console.log(
          '📊 Project status:',
          project.status,
          'Payment status:',
          project.payment_status,
        );

        const paymentCompleted =
          project.payment_status === 'completed' ||
          project.status?.toLowerCase() === 'in-progress' ||
          project.status?.toLowerCase() === 'awaiting artisan' ||
          project.status?.toLowerCase() === 'active' ||
          project.status?.toLowerCase() === 'completed';

        if (paymentCompleted) {
          console.log('✅ Payment verified successfully!');
          toast.success('🎉 Payment confirmed! Your project is now active.');
          clearInterval(intervalId);

          sessionStorage.removeItem('currentPaymentReference');
          sessionStorage.removeItem('currentProjectId');
          sessionStorage.removeItem('currentPaymentAmount');
          sessionStorage.removeItem('currentPaymentType');

          fetchClientProjects();
          navigate('/payments');
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          console.log('⏰ Max polling attempts reached');
          toast.info(
            'Payment verification taking longer than expected. Check your payments page for status.',
            { autoClose: 5000 },
          );
          navigate('/payments');
          return;
        }
      } catch (error) {
        console.error('❌ Error checking payment status:', error);

        if (error.response?.status === 404) {
          clearInterval(intervalId);
          toast.warning('Project not found. Please check your projects page.');
          navigate('/payments');
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          toast.info(
            'Payment verification timeout. Check your payments page for status.',
          );
          navigate('/payments');
        }
      }
    }, 3000);

    sessionStorage.setItem('pollingIntervalId', intervalId);
  };

  // ========== PROJECT MANAGEMENT FUNCTIONS ==========
  const handleDeleteProject = async () => {
    if (!deleteRequest) return;
    try {
      await serverUrlAuth.delete(
        `projects/client-project/${deleteRequest.id}/`,
      );
      toast.success(`Project "${deleteRequest.title}" deleted`);
      setRequests((prev) => prev.filter((r) => r.id !== deleteRequest.id));
      setDeleteRequest(null);
    } catch (err) {
      toast.error('Failed to delete project');
    }
  };

  const handleEditProject = async () => {
    if (!editRequest) return;
    try {
      const formData = new FormData();
      Object.entries(projectData).forEach(([key, value]) =>
        formData.append(key, value),
      );
      newImages.forEach((file) => formData.append('images', file));

      await serverUrlAuth.patch(
        `projects/client-project/${editRequest.id}/`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      toast.success(`Project "${projectData.title}" updated`);
      setEditRequest(null);
      resetEditForm();
      fetchClientProjects();
    } catch (err) {
      toast.error('Failed to update project');
    }
  };

  // ========== RATING FUNCTIONS ==========
  const handleSubmitRating = async () => {
    if (!rating || !viewRequest?.id) {
      toast.error('Please select a rating');
      return;
    }

    setIsSubmittingRating(true);
    try {
      const formData = new FormData();
      formData.append('score', rating);
      formData.append('review', ratingReview);
      ratingImages.forEach((file) => formData.append('images', file));

      const res = await serverUrlAuth.post(
        `reviews/project-review/${viewRequest.id}/create/`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      toast.success('Review submitted successfully!');
      setExistingRating(res.data);
      resetRatingForm();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to submit rating');
    } finally {
      setIsSubmittingRating(false);
    }
  };

  // ========== UI HANDLERS ==========
  const handleSelectArtisan = (match) => {
    if (!match.has_proposal) {
      toast.error('No proposal found for this artisan');
      return;
    }

    if (viewingProposal && viewingProposal.proposal_id === match.proposal_id) {
      match = {
        ...match,
        proposed_price: viewingProposal.proposed_price,
        final_agreed_amount:
          viewingProposal.final_agreed_amount || viewingProposal.proposed_price,
      };
    }

    setSelectedMatchForConfirm(match);
    setShowConfirmModal(true);
  };

  const handleViewProposal = async (match) => {
    if (!match.has_proposal || !match.proposal_id) {
      toast.error('No proposal found for this artisan');
      return;
    }

    try {
      const proposal = await fetchProposalDetails(match.proposal_id);
      if (proposal) {
        setViewingProposal({
          ...proposal,
          artisan_name: match.artisan_name,
          artisan_id: match.artisan_id,
          proposal_id: match.proposal_id,
          proposed_price: proposal.proposed_price,
          final_agreed_amount:
            proposal.final_agreed_amount || proposal.proposed_price,
        });
        setShowProposalModal(true);
      }
    } catch (error) {
      console.error('Error viewing proposal:', error);
      toast.error('Failed to load proposal details');
    }
  };

  const confirmSelectArtisan = async () => {
    if (!selectedMatchForConfirm) return;

    setAcceptingProposal(true);
    try {
      await serverUrlAuth.patch(
        `proposals/${selectedMatchForConfirm.proposal_id}/select/`,
      );

      toast.success(
        `You have selected ${selectedMatchForConfirm.artisan_name} for this project!`,
      );

      setShowConfirmModal(false);

      const agreedAmount =
        selectedMatchForConfirm.final_agreed_amount ||
        selectedMatchForConfirm.proposed_price ||
        viewRequest?.budget;

      setSelectedProjectForPayment({
        id: viewRequest.id,
        proposal_id: selectedMatchForConfirm.proposal_id,
        title: viewRequest.title,
        artisan_name: selectedMatchForConfirm.artisan_name,
        artisan_id: selectedMatchForConfirm.artisan_id,
        agreed_cost: parseFloat(agreedAmount),
        budget: parseFloat(viewRequest?.budget || 0),
      });

      setShowPaymentModal(true);
      setViewRequest(null);
      fetchClientProjects();
      setSelectedMatchForConfirm(null);
    } catch (err) {
      console.error('Error selecting artisan:', err);
      toast.error(err.response?.data?.message || 'Failed to select artisan');
    } finally {
      setAcceptingProposal(false);
    }
  };

  const handleViewProject = async (project) => {
    setViewRequest(project);
    if (project.status?.toLowerCase() === 'open') {
      await fetchMatchedArtisans(project.id);
    }
    if (project.status?.toLowerCase() === 'completed') {
      fetchRating();
    }
  };

  const openPortfolio = async (artisanId, artisanName) => {
    const portfolioData = await fetchPortfolioData(artisanId);
    setPortfolioModal({ ...portfolioData, artisan_name: artisanName });
    setViewRequest(null);
  };

  const closePortfolio = () => setPortfolioModal(null);

  const openEditModal = (request) => {
    setEditRequest(request);
    setProjectData({
      title: request.title || '',
      description: request.description || '',
      budget: request.budget || '',
      location: request.location || '',
      deadline: request.deadline?.split('T')[0] || '',
    });
    setNewImages([]);
    setPreviewUrls([]);
  };

  const toggleBio = (artisanId) => {
    setExpandedBios((prev) => ({
      ...prev,
      [artisanId]: !prev[artisanId],
    }));
  };

  const toggleDescription = (projectId) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  // ========== UTILITY FUNCTIONS ==========
  const handleImageUpload = (e, setImages, setPreviews) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
    setPreviews((prev) => [
      ...prev,
      ...files.map((file) => URL.createObjectURL(file)),
    ]);
  };

  const handleRemoveImage = (index, setImages, setPreviews) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const resetRatingForm = () => {
    setRating(0);
    setRatingReview('');
    setRatingImages([]);
    setRatingPreviewUrls([]);
  };

  const resetEditForm = () => {
    setNewImages([]);
    setPreviewUrls([]);
  };

  // ========== CAROUSEL FUNCTIONS ==========
  const handleNext = (projectId, totalImages) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [projectId]: ((prev[projectId] || 0) + 1) % totalImages,
    }));
  };

  const handlePrev = (projectId, totalImages) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [projectId]:
        (prev[projectId] || 0) === 0
          ? totalImages - 1
          : (prev[projectId] || 0) - 1,
    }));
  };

  // ========== TIER HELPERS ==========
  const getTierBadgeClass = (tier) => {
    switch (tier?.toLowerCase()) {
      case 'bronze':
        return 'tier-bronze';
      case 'silver':
        return 'tier-silver';
      case 'gold':
        return 'tier-gold';
      default:
        return 'tier-bronze';
    }
  };

  const getTierIcon = (tier) => {
    switch (tier?.toLowerCase()) {
      case 'bronze':
        return '🥉';
      case 'silver':
        return '🥈';
      case 'gold':
        return '🥇';
      default:
        return '🥉';
    }
  };

  // ========== EFFECTS ==========
  useEffect(() => {
    const projectId = sessionStorage.getItem('openProjectMatches');
    const showMessage = sessionStorage.getItem('showPriceAgreedMessage');
    const artisanId = sessionStorage.getItem('selectedArtisanId');

    if (projectId) {
      setAutoOpenProjectId(projectId);
      if (showMessage) {
        setShowPriceAgreedMessage(true);
        setTimeout(() => setShowPriceAgreedMessage(false), 5000);
      }
      if (artisanId) {
        setSelectedArtisanId(artisanId);
      }
      sessionStorage.removeItem('openProjectMatches');
      sessionStorage.removeItem('showPriceAgreedMessage');
      sessionStorage.removeItem('selectedArtisanId');
    }
  }, []);

  useEffect(() => {
    if (autoOpenProjectId && requests.length > 0) {
      const project = requests.find(
        (r) => r.id.toString() === autoOpenProjectId.toString(),
      );
      if (project && project.status?.toLowerCase() === 'open') {
        handleViewProject(project);
        setAutoOpenProjectId(null);
      }
    }
  }, [requests, autoOpenProjectId]);

  useEffect(() => {
    fetchClientProjects();
  }, []);

  useEffect(() => {
    if (viewRequest) {
      setActiveImage(0);
      if (viewRequest.status?.toLowerCase() === 'open') {
        fetchMatchedArtisans(viewRequest.id);
      }
      if (viewRequest.status?.toLowerCase() === 'completed') {
        fetchRating();
      } else {
        resetRatingForm();
        setExistingRating(null);
      }
    }
  }, [viewRequest]);

  // Clean up camera on unmount
  useEffect(() => {
    return () => {
      stopCamera();
      ratingPreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  if (loading) {
    return (
      <div className="modern-dashboard">
        <div className="dashboard-loader">
          <div className="wooden-spinner"></div>
          <p>Crafting your experience...</p>
        </div>
      </div>
    );
  }

  // ========== RENDER ==========
  return (
    <>
      <FurnitureNavbar />
      <div className="modern-dashboard">
        {/* Hero Section */}
        <section className="hero-craftsmanship">
          <div className="hero-pattern"></div>
          <div className="hero-content-modern">
            <div className="welcome-badge">
              <span className="badge-icon">📋</span>
              <span>My Project Requests</span>
            </div>
            <h1 className="hero-title">
              <span className="gradient-text">Track & Manage</span>
              <span className="hero-accent">Your Projects</span>
            </h1>
            <p className="hero-subtitle">
              Keep track of all your custom furniture and design requests in one
              place. Monitor progress, review proposals, and connect with
              skilled artisans.
            </p>
            <div className="hero-actions">
              <Link to="/new-project" className="btn-primary-custom">
                <FaRocket /> Create New Project
              </Link>
            </div>
          </div>
        </section>

        {/* Quick Stats Dashboard */}
        <div className="stats-dashboard">
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#67320020', color: '#673200' }}
            >
              <FaProjectDiagram />
            </div>
            <div className="stat-content">
              <h3>
                {requests.filter((r) => r.status?.toLowerCase() === 'open')
                  .length || 0}
              </h3>
              <p>Open Projects</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#4caf5020', color: '#4caf50' }}
            >
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>
                {requests.filter(
                  (r) => r.status?.toLowerCase() === 'in-progress',
                ).length || 0}
              </h3>
              <p>In Progress</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#ff980020', color: '#ff9800' }}
            >
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>
                {requests.filter((r) => r.status?.toLowerCase() === 'completed')
                  .length || 0}
              </h3>
              <p>Completed</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#9c27b020', color: '#9c27b0' }}
            >
              <FaHandshake />
            </div>
            <div className="stat-content">
              <h3>
                {requests.reduce(
                  (sum, r) => sum + (r.proposals_count || 0),
                  0,
                ) || 0}
              </h3>
              <p>Total Proposals</p>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="filter-section-modern">
          <div className="filter-tabs">
            {['all', 'open', 'in-progress', 'completed'].map((status) => (
              <button
                key={status}
                className={`filter-tab ${filter === status ? 'active' : ''}`}
                onClick={() => setFilter(status)}
              >
                {status === 'all'
                  ? 'All Projects'
                  : status === 'in-progress'
                    ? 'In Progress'
                    : status.charAt(0).toUpperCase() + status.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="projects-showcase">
          <div className="section-header-modern">
            <h2>
              <span className="header-icon">📋</span>
              Your Projects
              <span className="header-line"></span>
            </h2>
          </div>

          {error ? (
            <div className="error-state">
              <p>{error}</p>
              <button onClick={fetchClientProjects} className="retry-btn">
                Try Again
              </button>
            </div>
          ) : filteredRequests.length === 0 ? (
            <div className="empty-state-modern">
              <div className="empty-icon">📭</div>
              <h3>No projects found</h3>
              <p>
                {requests.length === 0
                  ? "You haven't created any projects yet."
                  : `No ${filter !== 'all' ? filter : ''} projects found.`}
              </p>
              {requests.length === 0 && (
                <Link to="/new-project" className="btn-primary-custom">
                  <FaRocket /> Create Your First Project
                </Link>
              )}
            </div>
          ) : (
            <div className="projects-grid-modern">
              {filteredRequests.map((req) => (
                <div key={req.id} className="project-card-modern">
                  {/* Image Section at the top */}
                  <div className="card-image-section">
                    <img
                      src={
                        req.images?.length
                          ? req.images[0].image_url || req.images[0].image
                          : 'https://via.placeholder.com/400x200?text=No+Image'
                      }
                      alt={req.title}
                      className="card-image"
                    />
                    <span
                      className={`status-badge-overlay ${req.status?.toLowerCase().replace(' ', '-')}`}
                    >
                      {req.status}
                    </span>
                    {req.proposals_count > 0 &&
                      req.status?.toLowerCase() === 'open' && (
                        <span className="proposals-badge-overlay">
                          💼 {req.proposals_count}{' '}
                          {req.proposals_count === 1 ? 'proposal' : 'proposals'}
                        </span>
                      )}
                    {isPaymentPending(req.status) && (
                      <span className="payment-status-badge pending">
                        💳 Payment Required
                      </span>
                    )}
                    {req.payment_status === 'completed' && (
                      <span className="payment-status-badge completed">
                        ✅ Paid
                      </span>
                    )}
                  </div>

                  {/* Card Content */}
                  <div className="card-content-section">
                    {shouldShowPayButton(req.status) && (
                      <div className="pay-now-top-section">
                        <button
                          className="pay-now-top-btn"
                          onClick={() => handlePayNow(req)}
                          disabled={paymentLoading}
                        >
                          <FaWallet className="pay-icon" />
                          <span className="pay-text">
                            {isAwaitingFinalPayment(req.status)
                              ? 'Pay Balance'
                              : 'Pay Now'}
                          </span>
                          <span className="pay-amount">
                            KSh{' '}
                            {parseFloat(
                              req.agreed_cost || req.budget || 0,
                            ).toLocaleString()}
                          </span>
                        </button>
                      </div>
                    )}

                    {isAwaitingFinalPayment(req.status) && (
                      <div className="final-payment-banner">
                        <div className="banner-icon">🎉</div>
                        <div className="banner-text">
                          <h4>Project Complete!</h4>
                          <p>
                            Your project is ready. Make the final payment to
                            complete.
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="project-header">
                      <div className="project-title-section">
                        <h3>{req.title}</h3>
                      </div>
                      <div className="project-budget">
                        KSh{' '}
                        {parseFloat(
                          req.agreed_cost || req.budget || 0,
                        ).toLocaleString()}
                      </div>
                    </div>

                    <div className="project-details-preview">
                      <p className="project-description-preview">
                        {req.description?.substring(0, 80)}
                        {req.description?.length > 80 ? '...' : ''}
                      </p>
                      <div className="project-meta">
                        <span className="meta-item">
                          <FaCalendar /> Due:{' '}
                          {new Date(req.deadline).toLocaleDateString()}
                        </span>
                      </div>
                    </div>

                    <div className="project-footer-my-projects">
                      <button
                        className="project-action"
                        onClick={() => handleViewProject(req)}
                      >
                        {req.status?.toLowerCase() === 'open'
                          ? 'View Artisan Matches/Proposals '
                          : req.status?.toLowerCase() === 'completed'
                            ? existingRating
                              ? 'View Review →'
                              : 'Rate Project →'
                            : isAwaitingFinalPayment(req.status)
                              ? 'View Project →'
                              : 'View Details →'}
                      </button>

                      {(req.status?.toLowerCase() ===
                        'awaiting-deposit-payment' ||
                        isAwaitingFinalPayment(req.status)) && (
                        <button
                          className={`pay-action-btn ${
                            isAwaitingFinalPayment(req.status)
                              ? 'final-payment'
                              : ''
                          }`}
                          onClick={() => handlePayNow(req)}
                          disabled={paymentLoading || finalPaymentLoading}
                        >
                          <FaWallet />{' '}
                          {isAwaitingFinalPayment(req.status)
                            ? 'Pay Balance'
                            : 'Pay Now'}
                        </button>
                      )}

                      {shouldShowEditDelete(req.status) && (
                        <div className="action-buttons">
                          <button
                            className="edit-action"
                            onClick={() => openEditModal(req)}
                          >
                            Edit
                          </button>
                          <button
                            className="delete-action"
                            onClick={() => setDeleteRequest(req)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Project Details Modal with Matched Artisans */}
        <Modal
          show={!!viewRequest}
          onHide={() => setViewRequest(null)}
          centered
          size="xl"
          className="project-details-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {viewRequest?.status?.toLowerCase() === 'completed'
                ? 'Rate Project'
                : viewRequest?.status?.toLowerCase() === 'open'
                  ? 'Matched Artisans'
                  : 'Project Details'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {viewRequest && (
              <div className="modal-two-column-layout">
                {/* Left Side - Images */}
                <div className="modal-left-side">
                  <div className="image-carousel">
                    <div className="main-image-container">
                      <img
                        src={
                          viewRequest.images?.length
                            ? viewRequest.images[activeImage].image
                            : 'https://via.placeholder.com/400x300?text=No+Image'
                        }
                        alt={viewRequest.title}
                        className="main-image"
                      />
                    </div>
                    {viewRequest.images?.length > 1 && (
                      <div className="thumbnail-strip">
                        {viewRequest.images.map((img, idx) => (
                          <img
                            key={idx}
                            src={img.image}
                            alt={`Thumb ${idx + 1}`}
                            className={`thumbnail ${activeImage === idx ? 'active' : ''}`}
                            onClick={() => setActiveImage(idx)}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Side - Content */}
                <div className="modal-right-side">
                  <div className="content-section">
                    <h3 className="project-title">{viewRequest.title}</h3>

                    <div className="project-details">
                      <p>
                        <strong>Status:</strong> {viewRequest.status}
                      </p>
                      {!viewRequest.agreed_cost ? (
                        <p>
                          <strong>Budget:</strong> KSh{' '}
                          {parseFloat(viewRequest.budget).toLocaleString()}
                        </p>
                      ) : (
                        <p>
                          <strong>Agreed Cost:</strong> KSh{' '}
                          {parseFloat(viewRequest.agreed_cost).toLocaleString()}
                        </p>
                      )}
                      <p>
                        <strong>Deadline:</strong>{' '}
                        {new Date(viewRequest.deadline).toLocaleDateString()}
                      </p>
                      <p>
                        <strong>Location:</strong> {viewRequest.location}
                      </p>
                      <div className="description-section">
                        <strong>Description:</strong>
                        <p>{viewRequest.description}</p>
                      </div>
                    </div>

                    {/* Matched Artisans Section for Open Projects */}
                    {viewRequest.status?.toLowerCase() === 'open' && (
                      <div className="matched-artisans-section">
                        <div className="section-header">
                          <h4>
                            🤝 Matched Artisans ({matchedArtisans.length})
                          </h4>
                          <p className="match-info">
                            Based on your budget of KSh{' '}
                            {parseFloat(viewRequest.budget).toLocaleString()},
                            we've found skilled artisans who match your
                            requirements.
                          </p>
                        </div>

                        {loadingMatches ? (
                          <div className="loading-matches">
                            <div className="spinner"></div>
                            <p>Finding the best artisans for you...</p>
                          </div>
                        ) : matchedArtisans.length === 0 ? (
                          <div className="no-matches">
                            <div className="no-matches-icon">🔍</div>
                            <h5>No matches found yet</h5>
                            <p>
                              We're still looking for artisans who match your
                              requirements. Check back soon!
                            </p>
                          </div>
                        ) : (
                          <div className="matched-artisans-list">
                            {matchedArtisans.map((match) => (
                              <div
                                key={match.id}
                                className="matched-artisan-card"
                              >
                                <div className="artisan-header">
                                  <div className="artisan-avatar">
                                    <FaUserCircle className="avatar-placeholder" />
                                  </div>
                                  <div className="artisan-info">
                                    <h5>
                                      {match.artisan_name ||
                                        `Artisan ${match.artisan_id}`}
                                    </h5>
                                    <div className="artisan-meta">
                                      <div className="rating">
                                        <FaStar className="star-icon" />
                                        <span>
                                          {match.average_rating || 'New'}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="match-status">
                                    {match.has_proposal ? (
                                      <span
                                        className={`proposal-status-badge ${match.proposal_selected ? 'accepted' : 'pending'}`}
                                      >
                                        {match.proposal_selected
                                          ? '✅ Selected'
                                          : '📝 Proposal Received'}
                                      </span>
                                    ) : (
                                      <span className="proposal-status-badge no-proposal">
                                        <FaClock /> Waiting for Proposal
                                      </span>
                                    )}
                                  </div>
                                </div>

                                <div className="artisan-bio-preview">
                                  <p>
                                    {match.bio ||
                                      'Skilled artisan ready to work on your project.'}
                                  </p>
                                </div>

                                <div className="artisan-actions">
                                  <button
                                    className="view-portfolio-btn"
                                    onClick={() =>
                                      openPortfolio(
                                        match.artisan_id,
                                        match.artisan_name,
                                      )
                                    }
                                  >
                                    <FaBriefcase /> View Portfolio
                                  </button>

                                  {match.has_proposal ? (
                                    <>
                                      <button
                                        className="view-proposal-btn"
                                        onClick={() =>
                                          handleViewProposal(match)
                                        }
                                      >
                                        <FaFileAlt /> View Proposal
                                      </button>
                                      <button
                                        className="select-artisan-btn"
                                        onClick={() =>
                                          handleSelectArtisan(match)
                                        }
                                        disabled={acceptingProposal}
                                      >
                                        <FaCheckCircle />
                                        {acceptingProposal
                                          ? 'Selecting...'
                                          : 'Select Artisan'}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="waiting-proposal-btn"
                                      disabled
                                    >
                                      <FaClock /> Awaiting Proposal
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Rating Section for Completed Projects */}
                    {viewRequest.status?.toLowerCase() === 'completed' && (
                      <div className="rating-section">
                        {existingRating ? (
                          <div className="existing-rating">
                            <h5>Your Review</h5>
                            <div className="stars-display">
                              {[...Array(5)].map((_, i) => (
                                <FaStar
                                  key={i}
                                  className="star"
                                  color={
                                    i < existingRating.score
                                      ? '#ffc107'
                                      : '#e4e5e9'
                                  }
                                />
                              ))}
                            </div>
                            {existingRating.review && (
                              <div className="review-text">
                                <strong>Comment:</strong>{' '}
                                {existingRating.review}
                              </div>
                            )}
                            {existingRating.images?.length > 0 && (
                              <div className="rating-images">
                                <strong>Photos:</strong>
                                <div className="images-grid">
                                  {existingRating.images.map((img, idx) => (
                                    <img
                                      key={idx}
                                      src={img.image_url}
                                      alt={`Review ${idx + 1}`}
                                    />
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="new-rating">
                            <h4>Rate Your Experience</h4>
                            <div className="stars-rating">
                              <label>Your Rating:</label>
                              <div className="stars-container">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <FaStar
                                    key={star}
                                    className={`star ${
                                      star <= (hoverRating || rating)
                                        ? 'active'
                                        : ''
                                    }`}
                                    size={28}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onMouseLeave={() => setHoverRating(0)}
                                    onClick={() => setRating(star)}
                                  />
                                ))}
                              </div>
                              <div className="rating-value">
                                {rating > 0
                                  ? `You rated: ${rating} star${rating > 1 ? 's' : ''}`
                                  : 'Click to rate'}
                              </div>
                            </div>

                            <div className="review-section">
                              <label>Your Review (Optional)</label>
                              <textarea
                                placeholder="Share your experience..."
                                value={ratingReview}
                                onChange={(e) =>
                                  setRatingReview(e.target.value)
                                }
                                className="review-textarea"
                                rows="3"
                              />
                            </div>

                            {/* <div className="image-upload-section">
                              <label>Add Photos (Optional)</label>
                              <div className="file-upload-area">
                                <input
                                  type="file"
                                  multiple
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleImageUpload(
                                      e,
                                      setRatingImages,
                                      setRatingPreviewUrls,
                                    )
                                  }
                                  className="file-input"
                                />
                                <div className="upload-hint">
                                  <FaCamera className="upload-icon" />
                                  <div className="upload-text">
                                    <div className="upload-title">
                                      Click to upload images
                                    </div>
                                    <div className="upload-subtitle">
                                      PNG, JPG, WEBP up to 10MB
                                    </div>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="camera-upload-btn"
                                  onClick={startCamera}
                                >
                                  <FaCamera /> Take Photo
                                </button>
                              </div>

                              {ratingPreviewUrls.length > 0 && (
                                <div className="preview-images">
                                  {ratingPreviewUrls.map((url, idx) => (
                                    <div
                                      key={idx}
                                      className="preview-image-wrapper"
                                    >
                                      <img
                                        src={url}
                                        alt={`Preview ${idx + 1}`}
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveImage(
                                            idx,
                                            setRatingImages,
                                            setRatingPreviewUrls,
                                          )
                                        }
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div> */}
                            <div className="image-upload-section">
                              <label>Add Photos (Optional)</label>
                              <div className="upload-options-container">
                                {/* File Upload Area */}
                                <div className="file-upload-area">
                                  <input
                                    type="file"
                                    multiple
                                    accept="image/*"
                                    onChange={(e) =>
                                      handleImageUpload(
                                        e,
                                        setRatingImages,
                                        setRatingPreviewUrls,
                                      )
                                    }
                                    className="file-input"
                                  />
                                  <div className="upload-hint">
                                    <FaImage className="upload-icon" />
                                    <div className="upload-text">
                                      <div className="upload-title">
                                        Choose from Gallery
                                      </div>
                                      <div className="upload-subtitle">
                                        PNG, JPG, WEBP up to 10MB
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Camera Button - Uses native camera */}
                                <button
                                  type="button"
                                  className="camera-upload-btn"
                                  onClick={() => {
                                    // Create a hidden file input with capture attribute
                                    const cameraInput =
                                      document.createElement('input');
                                    cameraInput.type = 'file';
                                    cameraInput.accept = 'image/*';
                                    cameraInput.capture = 'environment'; // 'environment' for back camera, 'user' for front
                                    cameraInput.multiple = false;

                                    cameraInput.onchange = (e) => {
                                      const files = Array.from(e.target.files);
                                      if (files.length > 0) {
                                        // Add the captured photo to the rating images
                                        setRatingImages((prev) => [
                                          ...prev,
                                          ...files,
                                        ]);
                                        setRatingPreviewUrls((prev) => [
                                          ...prev,
                                          ...files.map((file) =>
                                            URL.createObjectURL(file),
                                          ),
                                        ]);
                                        toast.success(
                                          '📸 Photo captured successfully!',
                                        );
                                      }
                                      // Clean up
                                      document.body.removeChild(cameraInput);
                                    };

                                    // Handle cancellation
                                    cameraInput.oncancel = () => {
                                      document.body.removeChild(cameraInput);
                                    };

                                    document.body.appendChild(cameraInput);
                                    cameraInput.click();
                                  }}
                                >
                                  <FaCamera /> Take Photo
                                </button>
                              </div>

                              {ratingPreviewUrls.length > 0 && (
                                <div className="preview-images">
                                  {ratingPreviewUrls.map((url, idx) => (
                                    <div
                                      key={idx}
                                      className="preview-image-wrapper"
                                    >
                                      <img
                                        src={url}
                                        alt={`Preview ${idx + 1}`}
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveImage(
                                            idx,
                                            setRatingImages,
                                            setRatingPreviewUrls,
                                          )
                                        }
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            <button
                              className={`submit-rating-btn ${!rating ? 'disabled' : ''}`}
                              onClick={handleSubmitRating}
                              disabled={!rating || isSubmittingRating}
                            >
                              {isSubmittingRating
                                ? 'Submitting...'
                                : 'Submit Review'}
                            </button>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Final Payment Banner in Modal */}
                    {isAwaitingFinalPayment(viewRequest.status) && (
                      <div
                        className="final-payment-banner"
                        style={{ marginTop: '1.5rem' }}
                      >
                        <div className="banner-icon">🎉</div>
                        <div className="banner-text">
                          <h4>Project Complete!</h4>
                          <p>
                            Your project is ready. Please make the final payment
                            to complete. Amount:{' '}
                            <strong>
                              KSh{' '}
                              {parseFloat(
                                viewRequest.agreed_cost ||
                                  viewRequest.budget ||
                                  0,
                              ).toLocaleString()}
                            </strong>
                          </p>
                        </div>
                        <button
                          className="pay-now-btn-banner"
                          onClick={() => handlePayNow(viewRequest)}
                          disabled={paymentLoading || finalPaymentLoading}
                        >
                          <FaWallet /> Pay Balance Now
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* View Proposal Modal */}
        <Modal
          show={showProposalModal}
          onHide={() => {
            setShowProposalModal(false);
            setViewingProposal(null);
          }}
          centered
          size="lg"
          className="proposal-view-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Proposal from {viewingProposal?.artisan_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loadingProposal ? (
              <div className="proposal-loading">
                <div className="spinner"></div>
                <p>Loading proposal details...</p>
              </div>
            ) : viewingProposal ? (
              <div className="proposal-details">
                <div className="proposal-card">
                  <div className="proposal-header">
                    <div className="proposal-badge">
                      <FaFileAlt />
                      <span>Proposal Details</span>
                    </div>
                    <div
                      className={`proposal-status ${viewingProposal.is_selected ? 'accepted' : 'pending'}`}
                    >
                      {viewingProposal.is_selected
                        ? 'Accepted ✓'
                        : 'Pending Review'}
                    </div>
                  </div>

                  <div className="proposal-info-grid">
                    <div className="info-item">
                      <FaMoneyBillWave className="info-icon" />
                      <div>
                        <label>Proposed Amount</label>
                        <p className="amount">
                          KSh{' '}
                          {parseFloat(
                            viewingProposal.proposed_price || 0,
                          ).toLocaleString()}
                        </p>
                      </div>
                    </div>

                    <div className="info-item">
                      <FaCalendar className="info-icon" />
                      <div>
                        <label>Completion Date</label>
                        <p>
                          {viewingProposal.proposed_date_of_completion
                            ? new Date(
                                viewingProposal.proposed_date_of_completion,
                              ).toLocaleDateString()
                            : 'Not specified'}
                        </p>
                      </div>
                    </div>

                    <div className="info-item">
                      <FaClock className="info-icon" />
                      <div>
                        <label>Submitted On</label>
                        <p>
                          {viewingProposal.created_at
                            ? new Date(
                                viewingProposal.created_at,
                              ).toLocaleString()
                            : 'Date not available'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {viewingProposal.note && (
                    <div className="proposal-message">
                      <label>Message from Artisan</label>
                      <div className="message-content">
                        <FaEnvelope className="message-icon" />
                        <p>{viewingProposal.note}</p>
                      </div>
                    </div>
                  )}

                  {viewingProposal.is_selected && (
                    <div className="proposal-selected-note">
                      <FaCheckCircle />
                      <span>
                        This proposal has been selected for the project!
                      </span>
                    </div>
                  )}

                  {!viewingProposal.is_selected && (
                    <div className="proposal-actions">
                      <button
                        className="select-proposal-btn"
                        onClick={async () => {
                          await handleSelectArtisan({
                            proposal_id: viewingProposal.id,
                            artisan_name: viewingProposal.artisan_name,
                            has_proposal: true,
                            proposed_price: viewingProposal.proposed_price,
                            final_agreed_amount:
                              viewingProposal.final_agreed_amount ||
                              viewingProposal.proposed_price,
                          });
                          setShowProposalModal(false);
                          setViewingProposal(null);
                        }}
                        disabled={acceptingProposal}
                      >
                        <FaCheckCircle />
                        {acceptingProposal
                          ? 'Selecting...'
                          : 'Select This Proposal'}
                      </button>
                      <button
                        className="message-artisan-btn"
                        onClick={() => {
                          setShowProposalModal(false);
                          setViewingProposal(null);
                          navigate(
                            `/messages?proposal=${viewingProposal.id}&project=${viewRequest?.title}&artisan=${viewingProposal.artisan_name}`,
                          );
                        }}
                      >
                        <FaComments /> Message Artisan
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="proposal-error">
                <FaTimes className="error-icon" />
                <p>Failed to load proposal details</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowProposalModal(false);
                setViewingProposal(null);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal
          show={!!editRequest}
          onHide={() => setEditRequest(null)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Project Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editRequest && (
              <div className="edit-modal-content">
                <form className="edit-form">
                  <div className="form-group">
                    <label>Project Title</label>
                    <input
                      type="text"
                      value={projectData.title}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      value={projectData.description}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Budget (KSh)</label>
                    <input
                      type="number"
                      value={projectData.budget}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          budget: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      value={projectData.location}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          location: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Preferred Deadline</label>
                    <input
                      type="date"
                      value={projectData.deadline}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          deadline: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="form-group">
                    <label>Upload New Images</label>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={(e) =>
                        handleImageUpload(e, setNewImages, setPreviewUrls)
                      }
                    />
                  </div>

                  {previewUrls.length > 0 && (
                    <div className="image-preview-grid-edit">
                      {previewUrls.map((url, idx) => (
                        <div key={idx} className="image-card edit-image">
                          <img
                            src={url}
                            alt="Preview"
                            className="thumbnail-edit-image"
                          />
                          <button
                            type="button"
                            className="remove-btn"
                            onClick={() =>
                              handleRemoveImage(
                                idx,
                                setNewImages,
                                setPreviewUrls,
                              )
                            }
                          >
                            ✖
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </form>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setEditRequest(null)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleEditProject}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Modal */}
        <Modal
          show={!!deleteRequest}
          onHide={() => setDeleteRequest(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Delete Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {deleteRequest && (
              <p>
                Are you sure you want to delete{' '}
                <strong>{deleteRequest.title}</strong>?
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDeleteRequest(null)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteProject}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Portfolio Modal */}
        <Modal
          show={!!portfolioModal}
          onHide={closePortfolio}
          centered
          size="xl"
          className="portfolio-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {portfolioModal?.artisan_name}'s Portfolio
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="portfolio-content">
              <div className="artisan-profile">
                <div className="profile-header">
                  <div className="artisan-avatar">
                    <img
                      src={portfolioModal?.artisan_avatar}
                      alt={portfolioModal?.artisan_name}
                    />
                  </div>
                  <div className="profile-info">
                    <h3>{portfolioModal?.artisan_name}</h3>
                    <div className="rating-display">
                      <div className="stars">
                        {[...Array(5)].map((_, i) => (
                          <FaStar
                            key={i}
                            className="star"
                            color={
                              i < Math.round(portfolioModal?.client_rating || 0)
                                ? '#ffc107'
                                : '#e4e5e9'
                            }
                          />
                        ))}
                      </div>
                      <span className="rating-text">
                        {portfolioModal?.client_rating || '0'}/5
                      </span>
                    </div>
                    <span className="specialization">
                      {portfolioModal?.specialization || 'Furniture Artisan'}
                    </span>
                  </div>
                </div>
                <div className="artisan-bio">
                  <p
                    className={`bio-content ${expandedBios[portfolioModal?.artisan_id] ? 'expanded' : 'collapsed'}`}
                  >
                    {portfolioModal?.bio || 'No bio available'}
                  </p>
                  <button
                    className={`read-more-btn ${expandedBios[portfolioModal?.artisan_id] ? 'expanded' : ''}`}
                    onClick={() => toggleBio(portfolioModal?.artisan_id)}
                  >
                    {expandedBios[portfolioModal?.artisan_id]
                      ? 'Read Less'
                      : 'Read More'}
                  </button>
                </div>
              </div>

              <div className="portfolio-stats">
                <div className="stat-card">
                  <div className="stat-number">
                    {portfolioModal?.projects_completed || '0'}
                  </div>
                  <div className="stat-label">Projects Completed</div>
                </div>
                <div className="stat-card">
                  <div className="stat-number">
                    {portfolioModal?.years_of_experience || '0'}+
                  </div>
                  <div className="stat-label">Years Experience</div>
                </div>
              </div>

              <div className="portfolio-projects-section">
                <div className="section-title">
                  <h4>Featured Projects</h4>
                  <p>Explore the artisan's completed work and craftsmanship</p>
                </div>
                {portfolioModal?.portfolio_items?.length > 0 ? (
                  <div className="projects-grid">
                    {portfolioModal.portfolio_items.map((project) => (
                      <div key={project.id} className="portfolio-project-card">
                        <div className="carousel-container">
                          {project.images?.length > 0 ? (
                            <div className="carousel-wrapper">
                              {project.images?.map((img, index) => (
                                <img
                                  key={img.id}
                                  src={img.image}
                                  alt={`${project.title} ${index + 1}`}
                                  className={`carousel-image ${
                                    index === (carouselIndex[project.id] || 0)
                                      ? 'active-image'
                                      : 'inactive-image'
                                  }`}
                                />
                              ))}
                            </div>
                          ) : (
                            <div className="image-placeholder">
                              <FaImage className="placeholder-icon" />
                              <span className="placeholder-text">
                                No images available
                              </span>
                            </div>
                          )}
                          <button
                            className="carousel-btn left"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePrev(project.id, project.images.length);
                            }}
                          >
                            ‹
                          </button>
                          <button
                            className="carousel-btn right"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNext(project.id, project.images.length);
                            }}
                          >
                            ›
                          </button>
                          {project.images?.length > 1 && (
                            <div className="carousel-indicators">
                              {project.images.map((_, index) => (
                                <div
                                  key={index}
                                  className={`indicator ${
                                    index === (carouselIndex[project.id] || 0)
                                      ? 'active'
                                      : ''
                                  }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setCarouselIndex((prev) => ({
                                      ...prev,
                                      [project.id]: index,
                                    }));
                                  }}
                                />
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="project-info">
                          <h5>{project.title}</h5>
                          <div className="project-description">
                            <p
                              className={`description-content ${
                                expandedDescriptions[project.id]
                                  ? 'expanded'
                                  : 'collapsed'
                              }`}
                            >
                              {project.description}
                            </p>
                            {project.description &&
                              project.description.length > 100 && (
                                <button
                                  className={`read-more-btn ${
                                    expandedDescriptions[project.id]
                                      ? 'expanded'
                                      : ''
                                  }`}
                                  onClick={() => toggleDescription(project.id)}
                                >
                                  {expandedDescriptions[project.id]
                                    ? 'Read Less'
                                    : 'Read More'}
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="portfolio-empty-state">
                    <div className="empty-icon">🎨</div>
                    <h4>No Projects Yet</h4>
                    <p>
                      This artisan hasn't added any projects to their portfolio
                      yet.
                    </p>
                  </div>
                )}
              </div>

              <div className="skills-section">
                <h5>Specializations & Skills</h5>
                <div className="skills-grid">
                  {portfolioModal?.skills?.length > 0 ? (
                    portfolioModal.skills.map((skill, index) => (
                      <span key={index} className="skill-tag">
                        {skill}
                      </span>
                    ))
                  ) : (
                    <>
                      <span className="skill-tag">Woodworking</span>
                      <span className="skill-tag">Custom Furniture</span>
                      <span className="skill-tag">Carpentry</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closePortfolio}>
              Close Portfolio
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Confirmation Modal for Selecting Artisan */}
        <Modal
          show={showConfirmModal}
          onHide={() => {
            setShowConfirmModal(false);
            setSelectedMatchForConfirm(null);
          }}
          centered
          className="confirm-select-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Artisan Selection</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedMatchForConfirm && (
              <div className="confirmation-content">
                <div className="confirmation-icon">
                  <FaCheckCircle className="warning-icon" />
                </div>
                <p className="confirmation-question">
                  Are you sure you want to select{' '}
                  <strong>{selectedMatchForConfirm.artisan_name}</strong> for
                  this project?
                </p>

                <div className="confirmation-details">
                  <div className="detail-row">
                    <span className="detail-label">Project:</span>
                    <span className="detail-value">{viewRequest?.title}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Artisan:</span>
                    <span className="detail-value">
                      {selectedMatchForConfirm.artisan_name}
                    </span>
                  </div>
                  <div className="detail-row highlight">
                    <span className="detail-label">Agreed Amount:</span>
                    <span className="detail-value amount">
                      KSh{' '}
                      {selectedMatchForConfirm.final_agreed_amount
                        ? parseFloat(
                            selectedMatchForConfirm.final_agreed_amount,
                          ).toLocaleString()
                        : parseFloat(
                            selectedMatchForConfirm.proposed_price,
                          ).toLocaleString()}
                    </span>
                  </div>
                </div>

                <div className="confirmation-warning">
                  <p>
                    ⚠️ <strong>Note:</strong> Once you select this artisan:
                  </p>
                  <ul>
                    <li>
                      Other proposals for this project will be automatically
                      declined
                    </li>
                    <li>The artisan will be notified and project will start</li>
                    <li>
                      You will be able to communicate with the artisan through
                      messages
                    </li>
                    <li>This action cannot be undone</li>
                  </ul>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowConfirmModal(false);
                setSelectedMatchForConfirm(null);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={confirmSelectArtisan}
              disabled={acceptingProposal}
              className="confirm-select-btn"
            >
              {acceptingProposal ? (
                <>
                  <FaSpinner className="spinning" /> Selecting...
                </>
              ) : (
                <>
                  <FaCheckCircle /> Yes, Select Artisan
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ========== DEPOSIT PAYMENT MODAL ========== */}
        <Modal
          show={showPaymentModal}
          onHide={() => {
            setShowPaymentModal(false);
            setSelectedProjectForPayment(null);
          }}
          centered
          size="lg"
          className="payment-modal-modern"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FaWallet className="modal-title-icon" />
              Pay Deposit
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedProjectForPayment && (
              <div className="payment-content-modern">
                <div className="payment-summary-modern">
                  <h4>📋 Project Summary</h4>
                  <div className="summary-details-modern">
                    <div className="summary-row-modern">
                      <span className="summary-label">Project:</span>
                      <strong className="summary-value">
                        {selectedProjectForPayment.title}
                      </strong>
                    </div>
                    <div className="summary-row-modern">
                      <span className="summary-label">Artisan:</span>
                      <strong className="summary-value">
                        {selectedProjectForPayment.artisan_name}
                      </strong>
                    </div>
                    <div className="summary-row-modern highlight-row">
                      <span className="summary-label">Total Amount:</span>
                      <strong className="summary-value amount-value">
                        KSh{' '}
                        {selectedProjectForPayment.agreed_cost.toLocaleString()}
                      </strong>
                    </div>
                    <div className="summary-row-modern">
                      <span className="summary-label">Deposit (50%):</span>
                      <strong className="summary-value">
                        KSh{' '}
                        {(
                          selectedProjectForPayment.agreed_cost * 0.5
                        ).toLocaleString()}
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="payment-breakdown-modern">
                  <h6>Payment Breakdown</h6>
                  <div className="breakdown-row">
                    <span>Total Project Cost</span>
                    <span>
                      KSh{' '}
                      {selectedProjectForPayment.agreed_cost.toLocaleString()}
                    </span>
                  </div>
                  <div className="breakdown-row">
                    <span>Deposit (50%)</span>
                    <span className="breakdown-type">
                      KSh{' '}
                      {(
                        selectedProjectForPayment.agreed_cost * 0.5
                      ).toLocaleString()}
                    </span>
                  </div>
                  <div className="breakdown-row total">
                    <span>Total to Pay</span>
                    <span className="total-amount">
                      KSh{' '}
                      {(
                        selectedProjectForPayment.agreed_cost * 0.5
                      ).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowPaymentModal(false);
                setSelectedProjectForPayment(null);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (selectedProjectForPayment) {
                  initializeDepositPayment(
                    selectedProjectForPayment.proposal_id,
                  );
                }
              }}
              disabled={paymentLoading}
              className="pay-now-btn-modern"
            >
              {paymentLoading ? (
                <>
                  <FaSpinner className="spinning" /> Processing...
                </>
              ) : (
                <>
                  <FaWallet />
                  Pay Deposit
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ========== FINAL PAYMENT MODAL ========== */}
        <Modal
          show={showFinalPaymentModal}
          onHide={() => {
            setShowFinalPaymentModal(false);
            setSelectedProjectForFinalPayment(null);
          }}
          centered
          size="lg"
          className="payment-modal-modern final-payment-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FaWallet className="modal-title-icon" />
              Final Payment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedProjectForFinalPayment && (
              <div className="payment-content-modern">
                <div className="payment-summary-modern">
                  <h4>📋 Project Summary</h4>
                  <div className="summary-details-modern">
                    <div className="summary-row-modern">
                      <span className="summary-label">Project:</span>
                      <strong className="summary-value">
                        {selectedProjectForFinalPayment.title}
                      </strong>
                    </div>
                    <div className="summary-row-modern">
                      <span className="summary-label">Artisan:</span>
                      <strong className="summary-value">
                        {selectedProjectForFinalPayment.artisan_name}
                      </strong>
                    </div>
                    <div className="summary-row-modern highlight-row">
                      <span className="summary-label">Remaining Balance:</span>
                      <strong className="summary-value amount-value">
                        KSh{' '}
                        {(
                          selectedProjectForFinalPayment.agreed_cost * 0.5
                        ).toLocaleString()}
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="payment-breakdown-modern">
                  <h6>Payment Breakdown</h6>
                  <div className="breakdown-row">
                    <span>Total Project Cost</span>
                    <span>
                      KSh{' '}
                      {selectedProjectForFinalPayment.agreed_cost.toLocaleString()}
                    </span>
                  </div>
                  <div className="breakdown-row">
                    <span>Deposit Paid</span>
                    <span className="breakdown-type">
                      KSh{' '}
                      {(
                        selectedProjectForFinalPayment.agreed_cost * 0.5
                      ).toLocaleString()}
                    </span>
                  </div>
                  <div className="breakdown-row total">
                    <span>Final Payment</span>
                    <span className="total-amount">
                      KSh{' '}
                      {(
                        selectedProjectForFinalPayment.agreed_cost * 0.5
                      ).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowFinalPaymentModal(false);
                setSelectedProjectForFinalPayment(null);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (selectedProjectForFinalPayment) {
                  initializeFinalPayment(
                    selectedProjectForFinalPayment.proposal_id,
                  );
                }
              }}
              disabled={finalPaymentLoading}
              className="pay-now-btn-modern final-payment-btn"
            >
              {finalPaymentLoading ? (
                <>
                  <FaSpinner className="spinning" /> Processing...
                </>
              ) : (
                <>
                  <FaWallet />
                  Complete Final Payment
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ========== CAMERA MODAL ========== */}
        {/* ========== CAMERA MODAL ========== */}
        <Modal
          show={showCameraModal}
          onHide={() => {
            console.log('Closing camera modal');
            setShowCameraModal(false);
            stopCamera();
            setCapturedPhoto(null);
          }}
          centered
          size="lg"
          className="camera-modal-modern"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span className="camera-modal-title">📷 Take a Photo</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="camera-body-modern">
            <div className="camera-container-modern">
              {!capturedPhoto ? (
                <>
                  <video
                    ref={videoRef}
                    className="camera-video-modern"
                    autoPlay
                    playsInline
                    muted
                  />
                  <canvas ref={canvasRef} style={{ display: 'none' }} />
                  <div className="camera-controls-modern">
                    <button
                      className="capture-btn-modern"
                      onClick={capturePhoto}
                    >
                      <div className="capture-circle-modern" />
                    </button>
                    <button
                      className="close-camera-btn-modern"
                      onClick={() => {
                        setShowCameraModal(false);
                        stopCamera();
                      }}
                    >
                      <FaTimes /> Close
                    </button>
                  </div>
                </>
              ) : (
                <div className="captured-preview-modern">
                  <img
                    src={capturedPhoto.previewUrl}
                    alt="Captured"
                    className="captured-image-modern"
                  />
                  <div className="captured-controls-modern">
                    <button className="retake-btn-modern" onClick={retakePhoto}>
                      🔄 Retake
                    </button>
                    <button
                      className="save-photo-btn-modern"
                      onClick={saveCapturedPhoto}
                    >
                      <FaCheck /> Use Photo
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowCameraModal(false);
                stopCamera();
                setCapturedPhoto(null);
              }}
            >
              Cancel
            </Button>
            {capturedPhoto && (
              <Button variant="primary" onClick={saveCapturedPhoto}>
                Save Photo
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(MyRequests, 'client');
